/* cache-bust: 2026-06-12-v3swap-r2 (CDN served stale 66KB copy under the fresh ?v= — repo precedent: precut-v3-injector) */
/* bySize Workspace overlay (Owen v3.2) — restyle-in-place + rail
   --------------------------------------------------------------------------
   Loaded only on multiupload_vivid_v3 template.

   Single upload: untouched. Engine renders inline today's UI as normal.
   Multi upload (engine creates <multi-upload-wrapper>):
     1. Move the wrapper into the main product area (anchor)
     2. Add `bsws-multi` to <body> so CSS restyles it inline
     3. Build a rail of thumbnails next to the wrapper, one per block
     4. Click thumbnail → mark block as `.bsws-selected`; CSS hides others

   No DOM moves of block children. No projection. No race conditions.
   -------------------------------------------------------------------------- */
(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var rail = null;
  var coalesce = false;
  // Set to true once we've committed to reloading the page after a delete-to-
  // zero. Suppresses double-fires from cascading clicks and guarantees the
  // hide overlay (body.bsws-reloading) is the last visual state the user
  // sees before the fresh page paints.
  var bswsReloadPending = false;
  // Sticky: set true once we hand off to the native engine multi modal (2+
  // blocks). Keeps scan() in the native modal while the user deletes back down
  // to 1 (matching dtf-transfers) instead of re-engaging the v3 single inline
  // workspace — which tore the popup down and read as "the popup closed." A
  // fresh single upload has NO multi-upload-wrapper (blockCount 0), so it is
  // unaffected; resets at blockCount 0 (and on the delete-to-zero reload).
  var wasMulti = false;

  function init() {
    // bsws-flow: namespacing class set on body for ALL workspace styling.
    // Asset is gated to product.template_suffix == 'multiupload_vivid_v3' at
    // theme.liquid:597, so this class only ever appears on the v3 product —
    // zero risk of CSS leaking to other products. CSS rules anchor on
    // body.bsws-flow + (image-uploaded | bsws-multi) so visuals only apply
    // post-upload while staying mode-agnostic for shared treatment.
    document.body.classList.add('bsws-flow');

    // Per-upload precut for the bySize_popular.js / bySize.js engine family.
    // The engine stamps `properties.Precut` from each row's bare `precut` DOM
    // attribute (bySize_popular.js:4792 + :5026 read; :4896 + :5096 stamp).
    // The global checkbox `#preCutOption_multi` (multi mode) and `#preCutOption`
    // (single mode) mass-write `precut` to every row when changed
    // (bySize_popular.js:1887 / :1038). Our per-block toggle UI writes
    // `block.dataset.bswsPrecut = "Yes"|""` and applies that value to the
    // block's rows directly, bypassing the global. Because the engine ALSO
    // mass-writes `precut` from `applyItemNo()` (bySize_popular.js:4063) on
    // row-add events, we re-enforce per-block state on every scan tick and
    // again at capture-phase before cart submit.
    //
    // Intercept the global checkbox change so a programmatic toggle in multi
    // mode can't clobber per-block state. theme.liquid:598 (workspace, defer)
    // loads before :1084 (engine, defer) so our delegated handler binds first
    // and stopImmediatePropagation wins. The CSS hides the global UI so a real
    // user click can't reach it; this is belt-and-suspenders.
    if (window.jQuery) {
      window.jQuery(document).on('change.bsws', '#preCutOption_multi, #preCutOption', function (e) {
        if (document.body.classList.contains('bsws-multi')) {
          e.stopImmediatePropagation();
          this.checked = false;
        }
      });
    }

    // Capture-phase click before the engine's bubble-phase Add to Cart handler
    // (bySize_popular.js:1651). Re-apply per-block precut state on the rows so
    // the engine's items[] build (bySize_popular.js:5026) reads the correct
    // value for each row at submission time, regardless of any prior engine
    // mass-writes from applyItemNo or other paths.
    document.addEventListener('click', function (e) {
      if (!document.body.classList.contains('bsws-multi')) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.addToCartGroupItemsMultiple, proceed-to-checkout button, proceed-to-checkout a, .addToCartGroupItems')) {
        var w = document.querySelector('multi-upload-wrapper');
        if (w) enforcePerBlockPrecut(w);
      }
    }, true);

    applyLastRowMarginFix();

    // Pin scroll position across upload-commit DOM swaps. When the user
    // commits an upload (single or multi), the engine's pre-upload DOM
    // (dropzone, AI card, design-studio info) collapses and the post-
    // upload workspace (preview, sizes, controls) takes its place. The
    // two states have different heights so every element below the swap
    // region jumps. Mitigation: snapshot scroll position the moment a
    // state-change signal fires, restore on the next two frames after
    // layout settles.
    //
    // Signals watched:
    //   * <body class> changes (image-uploaded / bsws-multi toggled)
    //   * <uploaded-files-block> children added or removed (multi add)
    //
    // Desktop only (>= 769px) — iOS Safari fights against synchronous
    // scrollTo during input flows and we don't want to spook the
    // virtual-keyboard handling.
    // Smooth out the upload "page yank". Engine code (pdp_transferBySize
    // .js:371-373 and friends) calls `$('html, body').animate({scrollTop:
    // X}, 1000)` synchronously from the file-input change handler, plus
    // direct `window.scrollTo` / `scrollIntoView` in other paths. Earlier
    // attempt was a per-rAF snap-back, which created visible jitter as
    // the engine's animation pushed forward and we yanked back every
    // frame. Smoother fix: SUPPRESS the scroll calls entirely during an
    // upload window, so the page never moves.
    //
    // Suppression scope: any of these methods, invoked while the upload-
    // scroll window is active (1600ms after a file-input change/drop):
    //   * jQuery.fn.animate when targeting html/body with scrollTop
    //   * window.scrollTo / Window.prototype.scrollTo
    //   * Element.prototype.scrollIntoView
    //   * Element scrollTop setter on html/body
    //
    // Outside the window, all of these work normally.
    //
    // Desktop only — mobile users can still get whatever scroll behavior
    // the engine provides (often useful on small screens).
    var _bswsScrollSuppressUntil = 0;
    function openUploadScrollWindow() {
      if (!window.matchMedia('(min-width: 769px)').matches) return;
      // INITIAL upload only. The yank this suppresses is the pre-upload ->
      // workspace height swap, which by definition happens while there is no
      // image yet (image-uploaded is set by the engine AFTER it processes the
      // first file, so it's still false at this change/drop). Once we're in the
      // workspace, the file flows that fire this (drag-drop into "Add another
      // design", re-upload) legitimately JUMP TO TOP — same as native
      // dtf-transfers — so do NOT open the suppression window then; it would
      // eat the engine's scroll-to-top (Owen 2026-06-15, verified: a file-input
      // change while image-uploaded opened the window and ate scrollTo(0,0)).
      if (document.body.classList.contains('image-uploaded')) return;
      _bswsScrollSuppressUntil = Date.now() + 1600;
    }
    function uploadScrollSuppressed() {
      return Date.now() < _bswsScrollSuppressUntil;
    }
    function isHtmlOrBody(el) {
      return el === document.documentElement || el === document.body;
    }
    function jqueryIsHtmlOrBody($el) {
      if (!$el || typeof $el.toArray !== 'function') return false;
      var arr = $el.toArray();
      if (!arr.length) return false;
      for (var i = 0; i < arr.length; i++) if (!isHtmlOrBody(arr[i])) return false;
      return true;
    }

    // Earliest possible hook: file input change / drop event.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[type=file]')) openUploadScrollWindow();
    }, true);
    document.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
        openUploadScrollWindow();
      }
    }, true);

    // Patch jQuery.fn.animate. Defer until jQuery is on the page (workspace
    // JS is `defer`-loaded after the engine, so jQuery is already present
    // when init() runs, but be safe).
    function patchJQueryAnimate() {
      var $ = window.jQuery;
      if (!$ || !$.fn || !$.fn.animate || $.fn._bswsAnimatePatched) return;
      var orig = $.fn.animate;
      $.fn.animate = function (props, durOrOpts, easingOrCb, cb) {
        if (props && props.scrollTop !== undefined &&
            uploadScrollSuppressed() && jqueryIsHtmlOrBody(this)) {
          // Drop the scroll. Strip scrollTop and continue with whatever
          // else (if anything) was in the props bag.
          var stripped = {};
          for (var k in props) if (k !== 'scrollTop') stripped[k] = props[k];
          if (Object.keys(stripped).length === 0) {
            // Nothing left to animate — fire the callback if any and bail.
            var done = (typeof cb === 'function') ? cb
                     : (typeof easingOrCb === 'function') ? easingOrCb
                     : (typeof durOrOpts === 'function') ? durOrOpts
                     : null;
            if (done) setTimeout(done.bind(this), 0);
            return this;
          }
          return orig.call(this, stripped, durOrOpts, easingOrCb, cb);
        }
        return orig.call(this, props, durOrOpts, easingOrCb, cb);
      };
      $.fn._bswsAnimatePatched = true;
    }
    patchJQueryAnimate();
    // jQuery sometimes loads after our init in unusual setups; retry once.
    if (!window.jQuery) {
      setTimeout(patchJQueryAnimate, 100);
      setTimeout(patchJQueryAnimate, 500);
    }

    // Patch window.scrollTo for in-window suppressions of vertical scroll.
    var origScrollTo = window.scrollTo.bind(window);
    window.scrollTo = function (xOrOpts, y) {
      if (uploadScrollSuppressed()) {
        // Only suppress vertical scrolls during the upload window; ignore.
        return;
      }
      return origScrollTo(xOrOpts, y);
    };

    // Patch Element.scrollIntoView for in-window suppressions.
    var origSIV = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function (opts) {
      if (uploadScrollSuppressed()) return;
      return origSIV.call(this, opts);
    };

    // Belt-and-suspenders rAF watchdog. If the engine sneaks past the
    // patches above via a direct scrollTop assignment or some other path,
    // snap back. Only runs during the suppression window — outside that,
    // the user's scrolling is honored.
    var _bswsSavedY = null;
    function watchdog() {
      if (!uploadScrollSuppressed()) {
        _bswsSavedY = null;
        return;
      }
      if (_bswsSavedY === null) _bswsSavedY = window.scrollY;
      if (Math.abs(window.scrollY - _bswsSavedY) > 1) {
        origScrollTo(0, _bswsSavedY);
      }
      requestAnimationFrame(watchdog);
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type=file]')) {
        requestAnimationFrame(watchdog);
      }
    }, true);
    document.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
        requestAnimationFrame(watchdog);
      }
    }, true);

    // Block programmatic / post-load auto-focus on workspace inputs
    // (desktop only). Engine's +/- qty handlers (pdp_transferBySize.js:
    // 159,179 and pdp_transferBySize-multiupload.js:103,123) call `.focus()`
    // on the qty input after the user clicks plus or minus, and other
    // engine paths can focus width/height inputs after upload completion
    // or row creation. Per design feedback 2026-05-11 those auto-focuses
    // are unwanted on desktop in single + multi — they pop the cursor
    // into a field the user didn't ask for AND cause the browser to
    // scroll-into-view, jumping the layout.
    //
    // Strategy: monkey-patch `HTMLElement.prototype.focus` to intercept
    // any `.focus()` call. When the target is a workspace input on
    // desktop AND no real user gesture (mousedown/pointerdown/touchstart)
    // landed on the element within the last 350ms, swallow the call.
    // Otherwise pass through with `preventScroll: true` so even legitimate
    // user-clicked focus doesn't trigger scroll-into-view.
    //
    // Bonus: focusin listener (capture phase) blurs anything that slipped
    // through (e.g., Tab key navigation, label-for clicks). Belt and
    // suspenders.
    //
    // Mobile (<=768px) untouched — engine already gates `+/-` focus
    // behind `winScreen > 550`; design-notes autofocus on checkbox stays
    // useful on small screens.
    var bswsLastUserDown = {target: null, time: 0};
    function recordDown(e) {
      if (!e.isTrusted) return;
      bswsLastUserDown.target = e.target;
      bswsLastUserDown.time = Date.now();
    }
    document.addEventListener('mousedown', recordDown, true);
    document.addEventListener('pointerdown', recordDown, true);
    document.addEventListener('touchstart', recordDown, true);

    var BSWS_INPUT_SEL =
      'sizes-blocks .customQtyFile__qty, ' +
      'sizes-blocks .widthHeight__value, ' +
      'sizes-blocks .popularSizes, ' +
      'designer-notes textarea.designNotes';

    function bswsGestureMatchedFor(el) {
      var sinceDown = Date.now() - bswsLastUserDown.time;
      var ld = bswsLastUserDown.target;
      if (sinceDown >= 350 || !ld) return false;
      return ld === el ||
             (ld.contains && ld.contains(el)) ||
             (el.contains && el.contains(ld));
    }

    var origFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (options) {
      try {
        if (this && this.matches && this.matches(BSWS_INPUT_SEL) &&
            window.matchMedia('(min-width: 769px)').matches) {
          if (!bswsGestureMatchedFor(this)) {
            return; // swallow programmatic auto-focus
          }
          // Legitimate user-driven focus — still suppress scroll so
          // sticky layout doesn't jump.
          return origFocus.call(this, Object.assign({}, options, { preventScroll: true }));
        }
      } catch (e) { /* fall through to native */ }
      return origFocus.call(this, options);
    };

    document.addEventListener('focusin', function (e) {
      if (!window.matchMedia('(min-width: 769px)').matches) return;
      var t = e.target;
      if (!t || !t.matches || !t.matches(BSWS_INPUT_SEL)) return;
      if (bswsGestureMatchedFor(t)) return;
      setTimeout(function () { try { t.blur(); } catch (err) {} }, 0);
    }, true);

    // Designer-notes textarea autofocus — when the user checks the "Add Free
    // design notes (optional)" box on MOBILE, the engine reveals the sibling
    // textarea and we focus it so the field is ready to type into. Desktop
    // skip — covered by the global no-auto-focus rule above.
    //
    // Delegated so it covers both single mode (one designer-notes) and multi
    // mode (one per uploaded-files-block).
    document.addEventListener('change', function (e) {
      var cb = e.target;
      if (!cb || !cb.matches) return;
      if (!cb.matches('designer-notes input.checkbox-field')) return;
      if (!cb.checked) return;
      if (window.matchMedia('(min-width: 769px)').matches) return;
      var dn = cb.closest('designer-notes');
      if (!dn) return;
      var ta = dn.querySelector('textarea.designNotes');
      if (!ta) return;
      // Wait a tick so the engine's :checked + label + textarea display:block
      // rule applies before we focus (focus on a display:none element is a
      // no-op in most browsers).
      setTimeout(function () { ta.focus(); }, 50);
    });

    // Delete-to-zero → reload for a clean baseline. Wait-for-scan was visibly
    // jumpy because the engine repaints the post-teardown DOM (briefly showing
    // an unstyled half-state) before our scan-based reload fires. Instead:
    // detect the click that COMMITS the delete (either the confirmation
    // dialog's button, the rail's delete X which auto-confirms in our
    // handler, or single-mode's direct delete links), paint a white cover via
    // body.bsws-reloading IMMEDIATELY in the same task, and reload on the
    // next microtask. The engine's handler still runs (does cart-side cleanup
    // via fire-and-forget calls); the user sees a clean white screen instead
    // of the intermediate state, then the freshly-loaded page.
    var DELETE_TO_ZERO_SEL =
      'file-remove-wrapper .fileRemoveBlock__removeFile, ' +
      'file-remove-wrapper-multi .fileRemoveBlock__removeFile, ' +
      '#fileremove-single, ' +
      'upload-controls preview-box a[removefile], ' +
      'multi-upload preview-box a[removefile]';
    document.addEventListener('click', function (e) {
      if (bswsReloadPending) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest(DELETE_TO_ZERO_SEL)) return;
      // Will this click bring us to zero uploads? Judge by ACTUAL block count,
      // NOT the `bsws-multi` body class. scan() (below) removes bsws-multi once
      // there are 2+ blocks (2026-06-04 revert → hand off to the native engine
      // modal), so the old `isSingle = !hasClass('bsws-multi')` test was wrongly
      // true in genuine multi mode and reloaded the whole page on EVERY per-line
      // delete instead of removing one line. Genuine single mode has no populated
      // multi-upload-wrapper (blockCount 0), so delete-to-zero still reloads.
      var w = document.querySelector('multi-upload-wrapper');
      var blockCount = w ? w.querySelectorAll('uploaded-files-block').length : 0;
      var willBeZero = blockCount <= 1;
      if (!willBeZero) return;
      bswsReloadPending = true;
      document.body.classList.add('bsws-reloading');
      // Microtask so the engine's same-task handlers (e.g. cart cleanup) run
      // first. setTimeout(0) is fine — reload kicks off before paint.
      setTimeout(function () { location.reload(); }, 0);
    }, true);

    // Park the size guide before any non-rail delete click (engine's own
    // preview-box X / [removefile] / file-remove confirm). Without this,
    // deleting the currently-selected block destroys the size guide (which
    // is a moved singleton living inside the selected block) and our
    // attachSizeGuide can't find it on the next selection. Multi mode only;
    // single mode's delete-to-zero already reloads the page via the
    // handler above.
    document.addEventListener('click', function (e) {
      if (!document.body.classList.contains('bsws-multi')) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var hit = t.closest(
        'multi-upload preview-box a[removefile], ' +
        '[data-id="fileremove-2"], ' +
        'file-remove-wrapper-multi .fileRemoveBlock__removeFile, ' +
        'file-remove-wrapper .fileRemoveBlock__removeFile'
      );
      if (!hit) return;
      // Find the block being deleted. For preview-box X, the block is the
      // closest ancestor. For the confirm button (which lives outside the
      // block, in a body-level dialog), use the currently-selected block.
      var targetBlock = t.closest('uploaded-files-block') ||
                        document.querySelector('uploaded-files-block.bsws-selected');
      parkSizeGuideFromBlock(targetBlock);
    }, true);

    // Scoped "Choose a Popular Size" link handler. The merchant-configured
    // `textInsideTabs` (rendered inside .sizeGuideTrigger) ships an
    // `<a class="popular-trigger">`. bySizeNew.liquid:4971 wires a click
    // handler using `querySelector('.popular-trigger')` and `querySelector
    // ('#popularSizeTabOption')` — both global. In multi mode our
    // ensureBlockChrome clones .sizeGuideTrigger + tab-controls into every
    // <uploaded-files-block>, so there are N copies of both the link and
    // the radio (with duplicate ids), and only the first pair gets wired —
    // clicks on links in blocks 2..N do nothing.
    //
    // Delegate at body level, scope to the closest block (or upload-
    // controls in single mode), and programmatically click that block's
    // radio so the engine's existing change-handler fires for the right
    // scope.
    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('.popular-trigger');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      var scope = trigger.closest('uploaded-files-block') ||
                  trigger.closest('upload-controls') ||
                  document;
      var radio = scope.querySelector('#popularSizeTabOption') ||
                  scope.querySelector('input.tabOptionName[value="popular"]');
      if (radio) radio.click();
    }, true);

    var observer = new MutationObserver(function () {
      if (coalesce) return;
      coalesce = true;
      requestAnimationFrame(function () {
        coalesce = false;
        scan();
      });
    });
    observer.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      // Watch `precut` + `dpi-warning` so engine mass-writes (applyItemNo
      // for precut; calculateDPILineItem for dpi-warning) trigger a scan
      // and let enforcePerBlock* restore per-block state.
      attributeFilter: ['class', 'src', 'precut', 'dpi-warning']
    });
    scan();

    // Periodic safety-net for the engine's silent height-wipe.
    // pdp_transferBySize-multiupload.js:1400 `updatePropotionalSizes` runs
    // on every block-switch / selection event with `parentContainer`
    // defaulting to `.master-upload`. In the workspace flow that selector
    // resolves to an off-layout hero (width()/height() return 0), so
    // `getNewRatio` returns "NaN:NaN", `calculateNewWidth_orNewHeight`
    // returns NaN, and `.val(NaN)` resolves to empty on the number input —
    // wiping the corrected height we just wrote. Engine sets the value via
    // jQuery `.val()` which doesn't fire a DOM mutation, so the
    // MutationObserver-driven scan above never notices and our
    // fixMultiBlockDimensions empty-height repair (workspace.js:1920) never
    // re-fires for that block. Poll once per second: scan() walks every
    // block, fixMultiBlockDimensions short-circuits on dimFixed=1 + valid
    // height, and re-derives dimensions from the block's own hero when the
    // height is blank/NaN. Cheap (~one querySelectorAll across N blocks
    // every 1000ms) and idempotent.
    // PERF (2026-06-10, LoAF-profiled): this safety-net poll contributed
    // ~600ms of long-frame time per 45s at rest. The MutationObserver above
    // already drives instant reactivity for everything DOM-mutating; the poll
    // only back-stops the engine's non-mutating jQuery .val() writes. Run it
    // at 2s instead of 1s and skip entirely while the tab is hidden — repair
    // latency for the silent-wipe edge case goes 1s -> 2s worst case, and the
    // mutation-driven scans still fire immediately.
    setInterval(function () {
      if (document.hidden) return;
      scan();
    }, 2000);

    var params = new URLSearchParams(location.search);
    if (params.has('bsws')) addDebugBar();
  }

  function scan() {
    var wrapper = document.querySelector('multi-upload-wrapper');
    // Multi mode is gated on block count, NOT the engine's .active flag.
    // Engine may keep .active set after the user deletes back to 0/1, but
    // we want our own threshold logic. Hysteresis: enter multi only at 2+
    // (a single fresh upload should keep today's bySizeNew flow), but once
    // active, stay active until count drops to 0 — collapsing back to single
    // mode at count=1 leaves the engine's wrapper visible without our multi
    // restyle and the page falls apart. Only return to the initial pre-
    // upload state when every block has been deleted.
    var blockCount = wrapper ? wrapper.querySelectorAll('uploaded-files-block').length : 0;
    // REVERT (2026-06-04): 2+ uploaded designs => native engine multi-upload
    // modal, matching /products/dtf-transfers. Do NOT hijack into the v3 inline
    // workspace. `bsws-flow` is the master gate for ALL v3 redesign CSS (and is
    // never read by JS logic — only as a CSS namespacing class), so dropping it
    // plus the mode classes lets the shared bySize.css full-screen overlay
    // render exactly as it does on dtf-transfers. Early-return BEFORE any
    // anchoring / rail / pager / restyle so zero chrome is injected into the
    // engine's modal. Single-upload (count < 2) is untouched: re-assert
    // bsws-flow so the v3 single redesign stays in effect.
    if (blockCount >= 2) {
      wasMulti = true;
      document.body.classList.remove('bsws-flow', 'bsws-multi', 'bsws-multi-loading');
      return;
    }
    // Collapsing from multi (2 -> 1): stay in the native engine modal exactly
    // like dtf-transfers — do NOT re-engage the v3 single inline workspace
    // (re-engaging tore the popup down). Only blockCount 0 returns to v3.
    if (wasMulti && blockCount >= 1) {
      document.body.classList.remove('bsws-flow', 'bsws-multi', 'bsws-multi-loading');
      return;
    }
    if (blockCount === 0) { wasMulti = false; }
    document.body.classList.add('bsws-flow');
    var wasActive = document.body.classList.contains('bsws-multi');
    var active = wasActive ? blockCount > 0 : blockCount >= 2;
    document.body.classList.toggle('bsws-multi', active);
    // Tag elements that have different tag names per mode with shared
    // classes so Layer A CSS can target them with a single selector.
    // Engine emits <another-upload> in single, <another-upload-multi> in
    // multi; tagging both with `.bsws-flow__add-another` lets us style the
    // dropzone consistently. Same for <precut> (engine global, single
    // mode) and `.bsws-precut-toggle` (our per-block UI, multi mode).
    tagSharedClasses();
    attachTouchedListener();
    attachPreviewTabClickHandler();
    attachDpiInputTracker();
    applyLastRowMarginFix();
    ensureRewardPlacement(wrapper);
    // v3 PDP mobile (<=899px): cashback crest directly under the CTA (dtf parity).
    // (The centering CSS — and the modal-toolbar, swatch and pre-upload-column
    // rules that used to be injected here — migrated to bysize-v3-single-
    // override.css SECTION J on 2026-06-10; only DOM work remains in JS.)
    ensureV3CashbackOrder();
    // While uploading, hide the product header above the loader.
    ensureUploadHeaderHidden();
    // Preview caption: "...shown above." -> "...shown below." (image sits below it).
    ensureV3PreviewCaptionBelow();
    // Narrow line-items: keep column titles visible in the two-row (<=640) layout.
    ensureV3LineItemTitles();
    // V3 Swap (2026-06-12): the rail wrapper now hosts prices-table as the
    // sticky element; the preview card sits inline in the right column.
    ensureV3PreviewRail();
    // Upload loader: hold it on screen until the workspace actually paints.
    ensureV3LoaderBridge();
    // Hide below-fold sections during the upload swap (kills ~1.3 of CLS).
    ensureV3BelowFoldCalm();
    if (active) refreshMultiReward();
    if (active) {
      // Multi-upload mode: strip every single-mode style injection so NONE of
      // our v3 single-mode restyling leaks into the multi-upload layout. They
      // are injected only in the single-mode branch below and re-injected (id-
      // guarded) when the flow returns to single, so this is safe to run each
      // scan tick. Defends the multi flow regardless of the per-rule selectors.
      clearSingleModeStyleInjections();
      anchorWrapper(wrapper);
      ensureRail(wrapper);
      ensurePager(wrapper);
      ensurePrecutToggles(wrapper);
      ensureBlockChrome(wrapper);
      enforcePerBlockPrecut(wrapper);
      enforcePerBlockDpiWarnings(wrapper);
      ensureNudgedBlocks(wrapper);
      Array.prototype.forEach.call(
        wrapper.querySelectorAll('uploaded-files-block'),
        fixMultiBlockDimensions
      );
      refreshPricesTableForSelectedBlock(wrapper);
      syncRail(wrapper);
      syncPager(wrapper);
      ensureMultiUploadOverlay(wrapper);
      // Inject preview-box tabs into every block's preview-box (so the
      // framework travels with whichever block is selected), then move
      // the page-level size guide into the currently-selected block's
      // guide panel.
      var multiBlocks = wrapper.querySelectorAll('uploaded-files-block');
      Array.prototype.forEach.call(multiBlocks, function (blk) {
        var box = blk.querySelector('preview-box');
        if (box) {
          ensurePreviewTabs(box);
          syncPreviewTabsState(box);
          ensureTrashInTabRow(box);
          ensureToolbarDivider(box);
        }
      });
      var activeBox = getActivePreviewBox(wrapper);
      if (activeBox) attachSizeGuide(activeBox);
      // Engine's size-guide writers are global — refresh against the
      // selected block so labels + watermark reflect that design even
      // when it isn't the first block in document order.
      refreshSizeGuideForSelectedBlock(wrapper);
    } else {
      // Single mode (no .bsws-multi). Inject tabs into the engine's single
      // preview-box and host the size guide there. Guarded on image-
      // uploaded so we don't inject into an empty preview-box pre-upload.
      if (document.body.classList.contains('image-uploaded')) {
        var singleBox = getActivePreviewBox();
        if (singleBox) {
          // Single-mode tabbed card (DECISION 2, 2026-06): combine the preview
          // and the Ninja Size Guide into ONE tabbed card (tabs: Preview
          // [default] / Size Guide). These four calls build the tab system and
          // relocate the page-level size guide into the preview-box's guide
          // panel — the same machinery the multi-mode branch above uses. All are
          // idempotent (guard on dataset.bswsTabsReady / parent checks) so they
          // are safe to re-run on every scan() tick and survive re-renders.
          // The preview-box then lands in the LEFT column and the pricing +
          // size controls in the RIGHT column via the workspace.css baseline
          // (grid-column placement), with the v3 override no longer swapping it.
          ensurePreviewTabs(singleBox);
          syncPreviewTabsState(singleBox);
          attachSizeGuide(singleBox);
          ensureTrashInTabRow(singleBox);
          ensureZoomInCaptionRow(singleBox);
          ensureToolbarDivider(singleBox);
          ensurePreviewMaxSize(singleBox);
          // (ensureCaptionSizeFallback migrated to bysize-v3-single-override.css
          // SECTION K on 2026-06-10 — static CSS now, applies at first paint.)
          ensureNotePrecutRestyle(singleBox);
          ensureZoomTrashRefStyle(singleBox);
          ensureInterFont();
        }
        // Inject the size-guide heading bar (and restore even tile rows).
        // Outside the singleBox guard: targets .dtf_imgix_images directly.
        ensureSizeGuideBars();
        // Single-mode equivalent of fixMultiBlockDimensions — v3 engine
        // sometimes misreads the upload dimensions in single mode (writes
        // 0.25"×0.26" for a 2000×2089 hero). v2's engine path produces
        // correct numbers; mirror that here by reading hero.naturalWidth
        // / 300 and overwriting if the engine's value is wildly off.
        fixSingleDimensions();
      }
      teardownRail();
      // On exit-multi, propagate the surviving block's per-block precut state
      // back to the global #preCutOption / #preCutOption_multi so single-mode UI
      // is consistent. Per-block state was authoritative in multi mode; now
      // single-mode reads from the global, so we sync. (No-op when blockCount=0.)
      if (wasActive) syncSurvivorPrecutToGlobal();
      if (wasActive && blockCount === 0) {
        // Full exit (all designs deleted): the engine doesn't always remove
        // <multi-upload-wrapper> on the last delete, leaving residual preview-
        // box / file-blocks chrome in the DOM. Without bsws-multi the wrapper's
        // unstyled fallback hangs the page in a broken half-state. Remove it
        // ourselves; the engine re-clones from template[data-multi-id="main"]
        // next time multi activates.
        if (wrapper && wrapper.parentNode) {
          wrapper.parentNode.removeChild(wrapper);
        }
        // Engine sets `image-uploaded` on <body> when any file is committed.
        // It usually clears it on full delete but doesn't always; if it stays
        // set with no actual image, our focus-mode CSS (`body.image-uploaded:
        // not(.bsws-multi) ...`) leaves the page in a half-restyled empty
        // state. Verify there's no live hero image and clear the class.
        var liveHero = document.querySelector('upload-controls .fileupload_hero');
        var heroSrc = (liveHero && liveHero.src) || '';
        var heroIsPlaceholder = !heroSrc || heroSrc.indexOf('transparent.png') !== -1;
        if (heroIsPlaceholder) {
          document.body.classList.remove('image-uploaded');
        }
      } else if (wrapper && wrapper.classList.contains('active')) {
        // Partial exit (shouldn't happen now with hysteresis, but defensive):
        // strip .active so the wrapper doesn't re-trigger its popup chrome.
        wrapper.classList.remove('active');
      }
    }
  }

  // TODO: revisit unified upload loader (2026-05-10). Previous attempt was
  // reverted because the engine's per-stage `.hidden` toggling, our own
  // hide-during-loading CSS, and the parent container's grid layout
  // combined to produce a stack of bugs (flicker, count drops to 0, multi
  // pushing content down, single getting stuck). Future approach: either
  // replace the engine's loaders end-to-end (style + DOM) at the template/
  // Liquid level, or post a single full-width overlay only when we can
  // observe the engine's progress via a more reliable signal than DOM-
  // class polling. For the related delete-to-zero reload-cover, see the
  // capture-phase click handler in init().

  // Tag elements whose engine tag names differ between single and multi
  // mode with a shared class so Layer A CSS can target them once.
  //   - <another-upload> (single) and <another-upload-multi> (multi) both
  //     get .bsws-flow__add-another so the "Add another design" dropzone
  //     can be styled identically in both modes.
  //   - engine's <precut> (single global) and our injected per-block
  //     <precut> (multi) both get .bsws-flow__precut.
  // Idempotent — `classList.add` no-ops on already-tagged elements.

  // Force margin-bottom: 0 on the LAST .widthHeight__custom row in each
  // line-items-* parent. Engine's bySize.css / __blanksUploadHelper.css
  // set margin-bottom:10px on every row (via `multi-upload sizes-blocks
  // .widthHeight__custom[option-selected="custom"]` and similar). That
  // 10px leaks below the last row's border-bottom, widening the visible
  // gap between the row's divider and .add-more-block's link from 16px
  // (single's value) to 26px (multi's) — perceptible "extra padding
  // above" the link.
  //
  // CSS overrides lose to the engine's rule despite higher specificity
  // and `!important` (cause is the CORS-blocked stylesheet enumerating
  // after ours in cascade order with same-importance rules). Inline
  // style always wins over any stylesheet, so set it directly.
  //
  // Called from scan() so it re-applies to every sizes-blocks discovered
  // after init — particularly the per-block sizes-blocks injected when
  // multi mode spins up additional uploaded-files-block instances.
  function applyLastRowMarginFix() {
    var rows = document.querySelectorAll(
      'sizes-blocks line-items-custom .widthHeight__custom, ' +
      'sizes-blocks line-items-popular .widthHeight__custom'
    );
    var byParent = new Map();
    Array.prototype.forEach.call(rows, function (r) {
      var p = r.parentElement;
      if (!byParent.has(p)) byParent.set(p, []);
      byParent.get(p).push(r);
    });
    byParent.forEach(function (siblings) {
      siblings.forEach(function (r, i) {
        if (i === siblings.length - 1) {
          r.style.setProperty('margin-bottom', '0', 'important');
        } else {
          r.style.removeProperty('margin-bottom');
        }
      });
    });
  }

  function tagSharedClasses() {
    var addAnother = document.querySelectorAll('another-upload, another-upload-multi');
    Array.prototype.forEach.call(addAnother, function (el) {
      el.classList.add('bsws-flow__add-another');
    });
    var precut = document.querySelectorAll('precut, .bsws-precut-toggle');
    Array.prototype.forEach.call(precut, function (el) {
      el.classList.add('bsws-flow__precut');
    });
  }

  // Per-block multi-mode chrome injection: clone single-mode-only elements
  // into each <uploaded-files-block> so multi has the same DOM/visual
  // structure as single. Future CSS changes to a shared element (e.g.
  // changing .designerNote_and_preCut from 2-col to 1-col) automatically
  // affect both modes — that's the unification promise.
  //
  // Four injections per block:
  //   (1) .sizeGuideTrigger ("Need help with sizing? Choose a Popular Size")
  //       — engine renders it once in single mode (inside hidden .main-
  //       product when in multi). We clone the outerHTML into each block
  //       after <tab-controls>.
  //   (2) .popularOptionContent ("Select a print area and we'll size it
  //       for you.") — same situation as sizeGuideTrigger: engine renders
  //       it in single-mode markup; multi data-multi-id="fileBlock" template
  //       (snippets/__multiuploadSnippets.liquid:1773) omits it entirely.
  //       Clone after the block's sizeGuideTrigger so popular-tab text and
  //       custom-tab help-link occupy the same row visually. Visibility
  //       per tab is handled by workspace.css :has() rule.
  //   (3) .widthHeight__customHeader (the "Width | Height | Qty | Price |
  //       Total" column header row) — same omission in multi template.
  //       Clone as the first child of the block's <sizes-blocks> so the
  //       header sits above the rows. Engine's transferBySize.css:2888
  //       rule is ungated so the cloned header inherits display:grid
  //       layout automatically.
  //   (4) .designerNote_and_preCut wrapper — engine renders it natively in
  //       single mode wrapping <designer-notes> + <precut>. In multi we
  //       create the wrapper and move the block's <designer-notes> +
  //       per-block <precut> into it. Engine's CSS at bySize.css:1137
  //       (display:grid; grid-template-columns:repeat(2,1fr)) auto-applies
  //       so notes and precut sit side-by-side, identical to single.
  function ensureBlockChrome(wrapper) {
    if (!wrapper) return;
    // Cache single-mode source elements (rendered once in DOM, sit inside
    // the now-hidden .main-product). Use them as templates for per-block clones.
    var sizeGuideSource = document.querySelector('.main-product .sizeGuideTrigger') ||
                          document.querySelector('.sizeGuideTrigger:not(uploaded-files-block .sizeGuideTrigger)');
    var popularContentSource = document.querySelector('.main-product .popularOptionContent') ||
                               document.querySelector('.popularOptionContent:not(uploaded-files-block .popularOptionContent)');
    var headerSource = document.querySelector('.main-product .widthHeight__customHeader') ||
                       document.querySelector('.widthHeight__customHeader:not(uploaded-files-block .widthHeight__customHeader)');
    var blocks = wrapper.querySelectorAll('uploaded-files-block');
    Array.prototype.forEach.call(blocks, function (block) {
      // (1) sizeGuideTrigger — inject after the block's <tab-controls>
      if (sizeGuideSource && !block.querySelector(':scope .sizeGuideTrigger')) {
        var tabs = block.querySelector('tab-controls');
        if (tabs && tabs.parentNode) {
          var sgClone = sizeGuideSource.cloneNode(true);
          sgClone.setAttribute('data-bsws-cloned', '1');
          tabs.parentNode.insertBefore(sgClone, tabs.nextSibling);
        }
      }
      // (2) popularOptionContent — inject after sizeGuideTrigger (same row in
      //     workspace grid; visibility per-tab is CSS-driven). Falls back to
      //     after <tab-controls> if no sizeGuideTrigger clone landed yet.
      if (popularContentSource && !block.querySelector(':scope .popularOptionContent')) {
        var sgInBlock = block.querySelector(':scope .sizeGuideTrigger');
        var anchor = sgInBlock || block.querySelector('tab-controls');
        if (anchor && anchor.parentNode) {
          var pcClone = popularContentSource.cloneNode(true);
          pcClone.setAttribute('data-bsws-cloned', '1');
          anchor.parentNode.insertBefore(pcClone, anchor.nextSibling);
        }
      }
      // (3) widthHeight__customHeader — insert as first child of the block's
      //     <sizes-blocks> so the header row sits above line-items-custom and
      //     line-items-popular. Engine's ungated rule at transferBySize.css:
      //     2888 supplies display:grid + column template.
      if (headerSource && !block.querySelector(':scope .widthHeight__customHeader')) {
        var sb = block.querySelector('sizes-blocks');
        if (sb) {
          var hdrClone = headerSource.cloneNode(true);
          hdrClone.setAttribute('data-bsws-cloned', '1');
          sb.insertBefore(hdrClone, sb.firstChild);
        }
      }
      // (4) designerNote_and_preCut wrapper — wrap the block's
      // <designer-notes> and per-block <precut> together. Both must be
      // present (precut only exists after ensurePrecutToggles runs, so
      // ensurePrecutToggles is called before this in scan()).
      var existingDnpc = block.querySelector(':scope > .designerNote_and_preCut');
      if (!existingDnpc) {
        var notes = block.querySelector('designer-notes');
        var pcut  = block.querySelector(':scope > .bsws-precut-toggle');
        if (notes && pcut) {
          var dnpc = document.createElement('div');
          dnpc.className = 'designerNote_and_preCut';
          dnpc.setAttribute('data-bsws-injected', '1');
          // Insert the wrapper at the position of <precut> (since precut
          // is already a direct child of block — predictable place to
          // anchor). Then move both into it.
          pcut.parentNode.insertBefore(dnpc, pcut);
          dnpc.appendChild(notes);  // moves notes out of <line-items>
          dnpc.appendChild(pcut);
        }
      } else {
        // Snippet already rendered .designerNote_and_preCut (with
        // <designer-notes> inside but no precut after ensurePrecutToggles
        // stripped the inert snippet one). Move our functional .bsws-
        // precut-toggle from its append-to-block position into the wrapper
        // so cluster shows [Add Free design notes] + [Pre-cut my Transfers]
        // side-by-side via the engine's grid-template-columns:repeat(2,1fr).
        var strayPcut = block.querySelector(':scope > .bsws-precut-toggle');
        if (strayPcut && strayPcut.parentNode !== existingDnpc) {
          existingDnpc.appendChild(strayPcut);
        }
      }
    });
  }

  // Per-upload precut: inject (or sync) a per-block toggle UI inside each
  // <uploaded-files-block>. State is stored on `block.dataset.bswsPrecut`
  // ("Yes" or empty). The toggle writes the dataset and applies the value to
  // every `.widthHeight__custom[item]` row inside the block via the engine's
  // own `precut` DOM attribute (bySize_popular.js:4792 / :5026 read these per
  // row at cart submit). enforcePerBlockPrecut runs on every scan + capture-
  // phase Add-to-Cart so any engine mass-write (applyItemNo at :4063, change
  // handlers at :1887 / :1038) gets corrected.
  function ensurePrecutToggles(wrapper) {
    // Pin global checkboxes to false so any engine path that mass-writes
    // `precut` from the global (applyItemNo at :4063) writes empty string,
    // and our enforce step then restores per-block state. Programmatic
    // .checked does NOT fire change, so the global change handler doesn't run.
    var globals = document.querySelectorAll('#preCutOption_multi, #preCutOption');
    Array.prototype.forEach.call(globals, function (g) {
      if (g.checked) g.checked = false;
    });

    var blocks = wrapper.querySelectorAll('uploaded-files-block');
    Array.prototype.forEach.call(blocks, function (block, i) {
      // The multi snippet (__multiuploadSnippets.liquid:1182) renders its own
      // <precut id="preCutOption"> inside .designerNote_and_preCut. In multi
      // mode that snippet precut is inert — the engine-side change handler is
      // intercepted by the init-time `change.bsws` listener (forces unchecked,
      // stops propagation). It also reuses `id="preCutOption"` on every block,
      // producing duplicate IDs. Remove it before our functional, per-block
      // toggle is injected — our `.bsws-precut-toggle` (unique id, wired to
      // dataset.bswsPrecut) becomes the only precut in the block.
      var stalePrecuts = block.querySelectorAll(':scope precut:not(.bsws-precut-toggle)');
      Array.prototype.forEach.call(stalePrecuts, function (p) { p.parentNode.removeChild(p); });

      var existing = block.querySelector('.bsws-precut-toggle');
      var checked = block.dataset.bswsPrecut === 'Yes';
      if (existing) {
        // Re-sync visible checkbox state with the dataset (in case anything
        // changed it elsewhere — defensive).
        var cb = existing.querySelector('input[type="checkbox"]');
        if (cb && cb.checked !== checked) cb.checked = checked;
        return;
      }
      // Render the per-block precut card as a real <precut> element with
      // the engine's exact markup pattern. Engine's existing CSS at
      // assets/bySize.css:1225 styles any <precut> tag with the blue card
      // chrome — so a change to the engine's precut design automatically
      // applies here too. Single-mode global precut and our per-block
      // per-design precut look pixel-identical.
      var unique = 'bswsPrecutOption_' + i + '_' + Math.random().toString(36).slice(2, 7);
      var el = document.createElement('precut');
      el.classList.add('bsws-precut-toggle'); // keep the class as a marker for our query
      el.innerHTML =
        '<div class="preCut__text">' +
          '<span>Want to save time?</span>' +
          '<a class="openmodalbox" href="javascript://" onclick="(window.jQuery||window.$).fn?(window.jQuery||window.$)(\'.precut-popup\').show():null;return false;">' +
            '<img src="//ninja-transfers-cdn.imgix.net/info_da70c6e6-1e86-41d3-9035-2bf57d01d406_medium.svg?auto=format,compress&v=1678797665" class="infoIcon infoModal grt-infoicon" alt="">' +
          '</a>' +
        '</div>' +
        '<label for="' + unique + '">' +
          '<input type="checkbox" id="' + unique + '"' + (checked ? ' checked' : '') + '>' +
          ' Pre-cut my Transfers <strong class="nodisplay precut-cost">$0.19 each</strong>' +
        '</label>';
      el.querySelector('input[type="checkbox"]').addEventListener('change', function () {
        onPrecutToggle(block, this.checked);
      });
      block.appendChild(el);
    });
  }

  function onPrecutToggle(block, checked) {
    block.dataset.bswsPrecut = checked ? 'Yes' : '';
    enforceBlockPrecut(block);
    refreshBlockPrices(block);
    // Force rail tile repaint so the PRE pill updates. syncRail's change-key
    // includes the precut state; clearing the cached key forces a redraw.
    var tiles = (rail && rail.querySelectorAll('.bsws-rail__tile')) || [];
    Array.prototype.forEach.call(tiles, function (t) { delete t.dataset.bswsKey; });
    var w = document.querySelector('multi-upload-wrapper');
    if (w) syncRail(w);
  }

  // Apply one block's per-block precut state to all its rows.
  function enforceBlockPrecut(block) {
    var desired = block.dataset.bswsPrecut === 'Yes' ? 'Yes' : '';
    var rows = block.querySelectorAll('.widthHeight__custom[item]');
    Array.prototype.forEach.call(rows, function (row) {
      var current = row.getAttribute('precut') || '';
      if (current !== desired) row.setAttribute('precut', desired);
    });
  }

  // Apply per-block precut state across all blocks in the wrapper.
  // Idempotent — only writes attrs that differ from the desired state, so
  // back-to-back calls don't loop the MutationObserver.
  function enforcePerBlockPrecut(wrapper) {
    if (!wrapper) return;
    var blocks = wrapper.querySelectorAll('uploaded-files-block');
    Array.prototype.forEach.call(blocks, function (block) {
      enforceBlockPrecut(block);
    });
  }

  // Per-block DPI warning latch.
  //
  // The engine's DPI logic uses global selectors
  // (`sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"]
  // dpi-warning`) and a global `uploadedFileWidth/Height` (one-design-at-a-
  // time). In multi mode every block has rows with the same item numbers,
  // so editing block B clobbers block A's warning state — warnings vanish
  // without the underlying issue being fixed.
  //
  // We don't replicate the engine's math (the engine reads original-pixel
  // dimensions captured at upload time, not naturalWidth of the rendered
  // thumbnail — a previous attempt at math replication produced false-
  // NO-WARN for low-res designs). Instead, latch the warning state per
  // row:
  //
  //   * Snapshot `.active` whenever the engine sets it (positive event).
  //   * Clear the latch only when the user has actively edited THIS row's
  //     inputs and the engine subsequently determines no warning needed
  //     (after a settle window).
  //   * On every scan tick, if latch says "should warn" but `.active`
  //     was cleared without a recent edit on this row, restore it.
  //
  // The latch is asymmetric: warnings persist until the user-edited row
  // is recomputed clean. Engine clobbers from other-block edits are
  // reverted within one tick.
  function enforcePerBlockDpiWarnings(wrapper) {
    if (!wrapper) return;
    var now = Date.now();
    var blocks = wrapper.querySelectorAll('uploaded-files-block');
    Array.prototype.forEach.call(blocks, function (block) {
      var rows = block.querySelectorAll('.widthHeight__custom[item]');
      Array.prototype.forEach.call(rows, function (row) {
        var dpiEl = row.querySelector('dpi-warning');
        if (!dpiEl) return;
        // Snapshot current state into latch — engine's writes (which we
        // can't predict) get persisted, and on block-switch when the
        // engine clobbers `.active` we have the truth.
        var nowActive = dpiEl.classList.contains('active');
        if (nowActive) {
          if (row.dataset.bswsDpiLatched !== '1') row.dataset.bswsDpiLatched = '1';
        }
        // Attach per-element observer (idempotent) to handle the
        // restore SYNCHRONOUSLY. The previous scan-based approach took
        // ~16ms to react via rAF coalescing, which manifested as a
        // visible flicker when the engine repeatedly clobbered `.active`
        // on block selection.
        attachDpiWarningGuard(dpiEl, row);
      });
    });
  }

  // Per-`<dpi-warning>` MutationObserver that synchronously re-adds
  // `.active` when the engine removes it, provided the row is latched
  // and not in a user-edit window. Runs on the same microtask as the
  // engine's mutation, so the flicker window is 0ms.
  //
  // Edit window = SETTLE_MS (3500ms). Engine has internal 1000+1500ms
  // timeouts; the post-edit snapshot in attachDpiInputTracker fires at
  // 2700ms; SETTLE_MS must be strictly greater than both so the guard
  // allows engine writes to land AND the snapshot captures the
  // engine's final assessment, before the guard reactivates.
  function attachDpiWarningGuard(dpiEl, row) {
    if (dpiEl._bswsGuarded) return;
    dpiEl._bswsGuarded = true;
    new MutationObserver(function () {
      var now = Date.now();
      var suppressedUntil = parseInt(row.dataset.bswsDpiSuppressedUntil || '0', 10);
      var nowActive = dpiEl.classList.contains('active');
      // SUPPRESS-WINDOW: directly after a dim-fix the engine may
      // briefly mark the row bad on block-switch using stale globals.
      // Strip any `.active` it adds within the suppression window.
      if (nowActive && now < suppressedUntil) {
        dpiEl.classList.remove('active');
        if ((row.getAttribute('dpi-warning') || '') !== '') {
          row.setAttribute('dpi-warning', '');
        }
        return;
      }
      // RESTORE-LATCH: outside the user-edit window, if we previously
      // latched `.active` on this row and the engine cleared it
      // (cross-block global-selector clobber), re-add synchronously.
      var latched = row.dataset.bswsDpiLatched === '1';
      if (!latched) return;
      var lastEdit = parseInt(row.dataset.bswsLastEdit || '0', 10);
      var sinceEdit = now - lastEdit;
      if (sinceEdit < 3500) return; // recent user edit — allow engine writes
      if (!nowActive) {
        dpiEl.classList.add('active');
        if ((row.getAttribute('dpi-warning') || '') !== 'Yes') {
          row.setAttribute('dpi-warning', 'Yes');
        }
      }
    }).observe(dpiEl, { attributes: true, attributeFilter: ['class'] });
  }

  // Capture-phase listener — record user-edit timestamps on width/height/
  // qty inputs and popular-size selects, plus schedule a post-settle
  // snapshot. After the engine's 1500ms recompute finishes, if the row's
  // warning is gone, clear the latch (user fixed the size).
  function attachDpiInputTracker() {
    if (window._bswsDpiTrackerAttached) return;
    window._bswsDpiTrackerAttached = true;
    function markEdit(target) {
      var row = target && target.closest && target.closest('.widthHeight__custom[item]');
      if (!row) return;
      row.dataset.bswsLastEdit = String(Date.now());
      if (row._bswsDpiSnap) clearTimeout(row._bswsDpiSnap);
      row._bswsDpiSnap = setTimeout(function () {
        var dpiEl = row.querySelector('dpi-warning');
        if (!dpiEl) return;
        // After engine settles, snapshot the truth for this row.
        row.dataset.bswsDpiLatched = dpiEl.classList.contains('active') ? '1' : '0';
      }, 2700);
    }
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('.widthHeight__value, .customQtyFile__qty, input[name*="qty"], input[name*="quantity"]')) {
        markEdit(t);
      }
    }, true);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('.popularSizes, select')) markEdit(t);
    }, true);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      // Engine's width/height +/- buttons (.widthHeight__value-plus,
      // .widthHeight__value-minus) and qty step (.customQtyFile__wrapper
      // __plus / __minus). jQuery `.val()` doesn't fire native input
      // events, so without catching these clicks the row never registers
      // as "recently edited" — the DPI guard then restores stale
      // warnings even after the user enters a good size.
      var btn = t.closest(
        '.widthHeight__value-plus, .widthHeight__value-minus, ' +
        '.widthHeight__item__action-plus, .widthHeight__item__action-minus, ' +
        '.customQtyFile__wrapper__plus, .customQtyFile__wrapper__minus, ' +
        '.qty-button, .widthHeight__option-button, ' +
        '[data-action*="increase"], [data-action*="decrease"]'
      );
      if (btn) markEdit(btn);
    }, true);
  }

  // Multi-mode prices-table per-tier price recalc. Engine's pricesTable()
  // at bySize_popular.js:5316 has an empty `else if (uploadType == 'multi')`
  // stub that never populates the per-tier discount values, leaving the
  // multi-mode "Buy More & Save" table showing "$ ea" placeholders instead
  // of real prices. We replicate the single-mode loop here, scoped to the
  // currently selected <uploaded-files-block> so the prices reflect THAT
  // block's chosen size variant (per the user's directive: "in multi upload
  // price should correspond to the upload they are on"). Cumulative qty
  // tier-detection is engine-driven and already works in both modes — only
  // the per-tier price text was missing.
  function refreshPricesTableForSelectedBlock(wrapper) {
    if (!wrapper) return;
    if (!document.body.classList.contains('bsws-multi')) return;
    var block = wrapper.querySelector('uploaded-files-block.bsws-selected');
    if (!block) return;
    var selectedRow = block.querySelector('.widthHeight__custom[item][option-selected]');
    if (!selectedRow) return;
    var unitPrice = parseFloat(selectedRow.getAttribute('price'));
    if (isNaN(unitPrice) || unitPrice <= 0) return;
    var pricesItems = wrapper.querySelectorAll('multi-upload prices-table .pricesTable__items .pricesTable__item');
    Array.prototype.forEach.call(pricesItems, function (item) {
      var off = parseFloat(item.getAttribute('off'));
      // Shopify-parity: floor the per-unit discount to whole cents like the cart does
      var unitCents = Math.round(unitPrice * 100);
      var offCents = (!off || isNaN(off)) ? 0 : Math.floor((unitCents * off) / 100);
      var calculated = ((unitCents - offCents) / 100).toFixed(2);
      var target = item.querySelector('.pricesTable__item_2 discount');
      if (target) target.textContent = calculated;
    });
  }

  // Per-block price refresh — the engine's price-render code reads the
  // global #preCutOption_multi to decide precut display, so it's not safe to
  // drive per-block. We replicate the unit-total display format inline
  // (mirrors the engine's `<precut-text>w/ precut</precut-text>` template).
  function refreshBlockPrices(block) {
    var yes = block.dataset.bswsPrecut === 'Yes';
    var rows = block.querySelectorAll('.widthHeight__custom[item]');
    Array.prototype.forEach.call(rows, function (row) {
      var price = parseFloat(row.getAttribute('price')) || 0;
      var precutPrice = parseFloat(row.getAttribute('precut-price')) || 0;
      var qty = parseInt(row.getAttribute('qty'), 10) || 0;
      var finalPrice = (yes && precutPrice > 0) ? precutPrice : price;
      var target = row.querySelector('.precut-unit-logic__total .__discountedPrice');
      if (!target) return;
      target.innerHTML = '$' + (finalPrice * qty).toFixed(2) +
        (yes ? '<precut-text>w/ precut</precut-text>' : '');
    });
  }

  // Multi → single transition: copy surviving block's per-block precut state
  // into the engine's global checkbox (#preCutOption / #preCutOption_multi)
  // and trigger change so the engine applies its existing side effects
  // (mass-write `precut` attr on the surviving rows — idempotent now).
  function syncSurvivorPrecutToGlobal() {
    var survivor = document.querySelector('uploaded-files-block');
    if (!survivor) return;
    var yes = survivor.dataset.bswsPrecut === 'Yes';
    var globals = document.querySelectorAll('#preCutOption_multi, #preCutOption');
    Array.prototype.forEach.call(globals, function (g) {
      if (g.checked !== yes) {
        g.checked = yes;
        if (window.jQuery) window.jQuery(g).trigger('change');
      }
    });
  }

  // Move <multi-upload-wrapper> from <body> bottom into the main product area
  // so it appears inline where the user expects it.
  function anchorWrapper(wrapper) {
    if (wrapper.dataset.bswsAnchored === '1') return;
    var anchor =
      document.querySelector('main .main-product') ||
      document.querySelector('section.main-product') ||
      document.querySelector('main') ||
      document.querySelector('.product-template-content');
    if (!anchor) return;
    anchor.parentNode.insertBefore(wrapper, anchor);
    wrapper.dataset.bswsAnchored = '1';
  }

  // Insert the rail container as the wrapper's first child so CSS grid
  // (rail + content) works without restructuring.
  // Pager element (multi only). Lives between Magenta (Design Notes / Pre-cut)
  // and Red (Add another design) in the workspace grid. Hidden if only 1 block.
  // Click on Next Transfer: advances to the next block, or jumps to the first
  // untouched block when on the last one. When all blocks are touched, the CTA
  // text flips to "Add to cart" and the click proxies to <proceed-to-checkout>.
  var pager = null;

  // Trigger the Red dropzone's Browse action — used by the rail's Add Another
  // tile so the rail tile and the Red dropzone share the same upload entry path.
  function clickRedBrowse() {
    var target =
      document.querySelector('multi-upload .bsws-flow__add-another b') ||
      document.querySelector('multi-upload .bsws-flow__add-another button') ||
      document.querySelector('.bsws-flow__add-another b') ||
      document.querySelector('.bsws-flow__add-another button') ||
      document.querySelector('.bsws-flow__add-another');
    if (target && target.click) target.click();
  }

  // Trigger the page's existing PROCEED TO CHECKOUT button. Used when the
  // pager flips to "Proceed to Checkout" state (all blocks touched).
  // The engine's delegated click handler (bySize_popular.js:1641 single,
  // :1651 multi) listens for `.addToCartGroupItems` / `.addToCartGroupItemsMultiple`
  // specifically — clicking the outer <proceed-to-checkout> wrapper or the
  // generic .button span won't fire the engine's handler.
  function clickProceedToCheckout() {
    var multiBtn = document.querySelector(
      'multi-upload-wrapper proceed-to-checkout .addToCartGroupItemsMultiple'
    );
    var singleBtn = document.querySelector(
      'upload-controls proceed-to-checkout .addToCartGroupItems'
    );
    var btn = multiBtn || singleBtn ||
      document.querySelector('.addToCartGroupItemsMultiple') ||
      document.querySelector('.addToCartGroupItems');
    if (btn && btn.click) btn.click();
  }

  // Read width/height/qty summary for a block. Pulls from the first
  // option-selected row (custom or popular). Returns empty strings if the
  // engine hasn't populated yet.
  function getBlockSummary(block) {
    var row =
      block.querySelector('.widthHeight__custom[option-selected]') ||
      block.querySelector('.widthHeight__custom');
    var w = '', h = '';
    if (row) {
      var wEl = row.querySelector('.widthHeight__value[name="width__value"]');
      var hEl = row.querySelector('.widthHeight__value[name="height__value"]');
      w = (wEl && wEl.value) || '';
      h = (hEl && hEl.value) || '';
    }
    var qtyEl = block.querySelector('.customQtyFile__qty');
    var qty = (qtyEl && qtyEl.value) || '';
    return { width: w, height: h, qty: qty };
  }

  // Mark a block as touched and re-sync rail + pager so the UI reflects the
  // new state. Idempotent — second call on a touched block is a no-op aside
  // from the syncs.
  function markBlockTouched(block) {
    if (!block || block.classList.contains('bsws-touched')) return;
    block.classList.add('bsws-touched');
    var w = document.querySelector('multi-upload-wrapper');
    if (w) {
      syncRail(w);
      syncPager(w);
    }
  }

  // One-time listener that watches for trusted user interactions on the size /
  // qty / popular-size inputs and marks the containing block as touched.
  // Per the project memory rule, mere selection of a tile does NOT mark it
  // touched — only an interaction with image, size, or qty. We filter on
  // `event.isTrusted` so engine-synthesized events (initial population,
  // nudgeEngine, etc.) don't false-positive.
  function attachTouchedListener() {
    if (window._bswsTouchedAttached) return;
    window._bswsTouchedAttached = true;
    // Engine classes vary between products. The size inputs use
    // .widthHeight__value (input) + .widthHeight__value-plus / -minus
    // (buttons). Qty: .customQtyFile__qty (input) + .customQtyFile__wrapper__plus
    // / -minus (some products have buttons, others a plain number input).
    // Popular tab uses .popularSizes (custom select). Match all of them so
    // every "change a size" interaction triggers touched.
    var TOUCH_SEL =
      '.widthHeight__value, ' +
      '.widthHeight__value-plus, .widthHeight__value-minus, ' +
      '.widthHeight__item__action-plus, .widthHeight__item__action-minus, ' +
      '.customQtyFile__qty, ' +
      '.customQtyFile__wrapper__plus, .customQtyFile__wrapper__minus, ' +
      '.popularSizes, .popularSizes_sticker, .popularSizes_puff';
    function handler(e) {
      if (!e.isTrusted) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest(TOUCH_SEL)) return;
      var block = t.closest('uploaded-files-block');
      if (!block) return;
      markBlockTouched(block);
    }
    document.body.addEventListener('input', handler, true);
    document.body.addEventListener('change', handler, true);
    document.body.addEventListener('click', handler, true);

    // Second listener — refresh size guide labels/watermark whenever the
    // user edits the SELECTED block's width/height inputs (or clicks the
    // +/- buttons that mutate them). Engine's calculateratioForImage()
    // runs on these events too, but reads globally — so we follow up
    // with a scoped refresh that uses the selected block's values.
    // Coalesced via rAF so back-to-back input events don't pile up.
    var refreshPending = false;
    function refreshHandler(e) {
      if (!e.isTrusted) return;
      if (!document.body.classList.contains('bsws-multi')) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest(TOUCH_SEL)) return;
      var block = t.closest('uploaded-files-block');
      if (!block || !block.classList.contains('bsws-selected')) return;
      if (refreshPending) return;
      refreshPending = true;
      requestAnimationFrame(function () {
        refreshPending = false;
        refreshSizeGuideForSelectedBlock();
      });
    }
    document.body.addEventListener('input', refreshHandler, true);
    document.body.addEventListener('change', refreshHandler, true);
    document.body.addEventListener('click', refreshHandler, true);
  }

  // Shared block-selection helper used by both the rail tile click handler and
  // the pager prev/next handler. Sets bsws-selected on the target block,
  // mirrors the is-selected class on the corresponding rail tile, nudges the
  // engine to recalculate dependent fields, and refreshes the prices table.
  function selectBlockByIdx(wrapper, idx) {
    if (!wrapper) return;
    var blocks = wrapper.querySelectorAll('uploaded-files-block');
    if (idx < 0 || idx >= blocks.length) return;
    Array.prototype.forEach.call(blocks, function (b) { b.classList.remove('bsws-selected'); });
    var block = blocks[idx];
    block.classList.add('bsws-selected');
    if (rail) {
      Array.prototype.forEach.call(rail.querySelectorAll('.bsws-rail__tile'), function (t, i) {
        t.classList.toggle('is-selected', i === idx);
      });
    }
    // BEFORE nudge: sync engine's global pixel dims to the new block's
    // hero AND open a DPI-suppression window on every row of the new
    // block. nudgeEngine triggers calculateDPILineItem which can flash
    // an orange warning against stale globals from the previously-
    // selected block. The suppression window + correct globals together
    // eliminate that.
    var newHero = block.querySelector('.fileupload_hero');
    if (newHero && newHero.naturalWidth > 0) {
      try {
        window.uploadedFileWidth = newHero.naturalWidth;
        window.uploadedFileHeight = newHero.naturalHeight;
      } catch (_) {}
    }
    var until = String(Date.now() + 4000);
    var newRows = block.querySelectorAll('.widthHeight__custom[item]');
    Array.prototype.forEach.call(newRows, function (r) {
      r.dataset.bswsDpiSuppressedUntil = until;
    });
    nudgeEngine(block);
    refreshPricesTableForSelectedBlock(wrapper);
    syncPager(wrapper);
    refreshMultiReward();
    // Re-anchor the page-level size guide into the newly-selected block's
    // preview-box guide panel. Move-based (not clone) so the engine's
    // global #dtf_body_image / .watermark_image img selectors keep
    // matching a single instance.
    var newBox = block.querySelector('preview-box');
    if (newBox) {
      ensurePreviewTabs(newBox);
      syncPreviewTabsState(newBox);
      attachSizeGuide(newBox);
    }
    // Engine's writers (calculateratioForImage + watermark setter) use
    // global selectors, so they don't follow selection — refresh labels
    // and watermark img to match the newly-selected block.
    refreshSizeGuideForSelectedBlock(wrapper);
  }

  // Inject the pager element into the multi grid (idempotent). Placed before
  // .bsws-flow__add-another so its grid-row sits between Magenta and Red.
  // Click handlers are wired once at injection time.
  function ensurePager(wrapper) {
    var inner = wrapper.querySelector('.multiUpload__inner__wrapper, .__multiUpload__inner__wrapper');
    if (!inner) return;
    if (pager && pager.parentNode === inner) return;
    pager = document.createElement('bsws-pager');
    pager.setAttribute('aria-label', 'Transfer navigation');
    pager.innerHTML =
      '<span class="bsws-pager__count" data-bsws-pager-count>1 of 1</span>' +
      '<button class="bsws-pager__prev" type="button" data-bsws-pager-prev>Previous</button>' +
      '<button class="bsws-pager__next" type="button" data-bsws-pager-next>Next Transfer</button>';
    // DOM order doesn't matter for grid placement — `grid-row: 6` (set in
    // workspace.css) anchors the pager between Magenta (row 5) and Red
    // (row 7) regardless of insertion order. Just append.
    inner.appendChild(pager);
    pager.querySelector('[data-bsws-pager-prev]').addEventListener('click', function (e) {
      e.preventDefault();
      var w = document.querySelector('multi-upload-wrapper');
      if (!w) return;
      var blocks = w.querySelectorAll('uploaded-files-block');
      var sel = w.querySelector('uploaded-files-block.bsws-selected');
      var idx = sel ? Array.prototype.indexOf.call(blocks, sel) : 0;
      if (idx > 0) selectBlockByIdx(w, idx - 1);
    });
    pager.querySelector('[data-bsws-pager-next]').addEventListener('click', function (e) {
      e.preventDefault();
      var w = document.querySelector('multi-upload-wrapper');
      if (!w) return;
      var blocks = w.querySelectorAll('uploaded-files-block');
      if (!blocks.length) return;
      // Cart mode (all touched) — proxy to PROCEED TO CHECKOUT.
      var allTouched = isAllBlocksTouched(blocks);
      if (allTouched) {
        clickProceedToCheckout();
        return;
      }
      var sel = w.querySelector('uploaded-files-block.bsws-selected');
      var idx = sel ? Array.prototype.indexOf.call(blocks, sel) : 0;
      if (idx < blocks.length - 1) {
        selectBlockByIdx(w, idx + 1);
        return;
      }
      // On the last tile and not all touched — jump to first untouched.
      for (var i = 0; i < blocks.length; i++) {
        if (!blocks[i].classList.contains('bsws-touched')) {
          selectBlockByIdx(w, i);
          return;
        }
      }
    });
  }

  function isAllBlocksTouched(blocks) {
    if (!blocks || !blocks.length) return false;
    for (var i = 0; i < blocks.length; i++) {
      if (!blocks[i].classList.contains('bsws-touched')) return false;
    }
    return true;
  }

  // Update the pager's count, prev-disabled, and Next/Add-to-cart label to
  // reflect current selection and touched state. Hidden when there's only
  // one block (a single design doesn't need pagination).
  function syncPager(wrapper) {
    if (!pager) return;
    var blocks = wrapper.querySelectorAll('uploaded-files-block');
    if (blocks.length <= 1) {
      pager.setAttribute('data-bsws-pager-hidden', '1');
      return;
    }
    pager.removeAttribute('data-bsws-pager-hidden');
    var sel = wrapper.querySelector('uploaded-files-block.bsws-selected');
    var idx = sel ? Array.prototype.indexOf.call(blocks, sel) : 0;
    if (idx < 0) idx = 0;
    var countEl = pager.querySelector('[data-bsws-pager-count]');
    var prevEl = pager.querySelector('[data-bsws-pager-prev]');
    var nextEl = pager.querySelector('[data-bsws-pager-next]');
    if (countEl) countEl.textContent = (idx + 1) + ' of ' + blocks.length;
    if (prevEl) prevEl.disabled = idx === 0;
    if (nextEl) {
      var allTouched = isAllBlocksTouched(blocks);
      /* the pager's cart state wears the page's own button text (CMS: Buy Buttons → buttonText) */
      var ctaTextEl = document.querySelector('multi-upload-wrapper proceed-to-checkout .button__text, upload-controls proceed-to-checkout .button__text, .addToCartGroupItems .button__text');
      nextEl.textContent = allTouched ? ((ctaTextEl && ctaTextEl.textContent.trim()) || 'Add to Cart') : 'Next Transfer';
      nextEl.setAttribute('data-bsws-pager-mode', allTouched ? 'cart' : 'next');
    }
  }

  // ============================================================
  // Preview-box tabs: "Your Upload" / "Size Guide"
  //
  // Each preview-box gets a 2-tab framework injected. The Your Upload
  // panel wraps the engine's existing preview-box children (zoom link,
  // dimension lines, image, trash, footer controls, "Preview: …"
  // caption) so nothing about that flow changes — the engine continues
  // writing to preview-box .viewer-box img untouched.
  //
  // The Size Guide panel is a host for the single page-level
  // .dtf_imgix_images element. We MOVE the element (no clone) into the
  // currently-selected preview-box's guide panel so the engine's
  // hardcoded global selectors (#dtf_body_image, .watermark_image img,
  // calculateratioForImage()) keep working against a single instance.
  //
  // Active tab is stored on <body data-bsws-preview-tab="upload"|"guide">
  // so it persists across rail-tile switches in multi mode.
  // ============================================================

  // Wrap a preview-box's existing children in tab framework. Idempotent.
  // Returns the guide panel element (where the size guide should live).
  function ensurePreviewTabs(box) {
    if (!box) return null;
    if (box.dataset.bswsTabsReady === '1') {
      return box.querySelector(':scope > .bsws-tabpanel--guide');
    }
    // Capture existing children — they become the Your Upload panel.
    var existing = Array.prototype.slice.call(box.childNodes);
    var tabs = document.createElement('div');
    tabs.className = 'bsws-tabs';
    tabs.setAttribute('role', 'tablist');
    tabs.innerHTML =
      '<button type="button" class="bsws-tab" data-bsws-tab="upload" role="tab">Preview</button>' +
      '<button type="button" class="bsws-tab" data-bsws-tab="guide"  role="tab">Size Guide</button>';
    var uploadPanel = document.createElement('div');
    uploadPanel.className = 'bsws-tabpanel bsws-tabpanel--upload';
    uploadPanel.setAttribute('role', 'tabpanel');
    var guidePanel = document.createElement('div');
    guidePanel.className = 'bsws-tabpanel bsws-tabpanel--guide';
    guidePanel.setAttribute('role', 'tabpanel');
    // Move existing children into the upload panel — preserves engine
    // bindings since we move (not clone) the elements.
    existing.forEach(function (n) { uploadPanel.appendChild(n); });
    // Reassemble: tab bar, then both panels.
    box.appendChild(tabs);
    box.appendChild(uploadPanel);
    box.appendChild(guidePanel);
    box.dataset.bswsTabsReady = '1';
    return guidePanel;
  }

  // Relocate the engine's trash/delete button (`a[removefile]` inside
  // `.upload_tools`) into the `.bsws-tabs` row as its last flex child so
  // it sits on the upper-RIGHT, aligned with the Your Upload / Size Guide
  // tab buttons. We move (not clone) the element so engine click handlers
  // and DELETE_TO_ZERO_SEL (`preview-box a[removefile]`) keep matching.
  // CSS gives the trash `margin-left: auto` to push it to the right edge.
  //
  // Idempotent — no-op if the trash is already the last child of .bsws-tabs.
  function ensureTrashInTabRow(box) {
    if (!box) return;
    var tabs = box.querySelector(':scope > .bsws-tabs');
    if (!tabs) return;
    var trash = box.querySelector('a[removefile]');
    if (!trash) return;
    if (trash.parentElement === tabs && trash === tabs.lastElementChild) return;
    tabs.appendChild(trash);
  }

  // Move the magnify/zoom button out of the deeply-nested image container
  // (preview-block.easyzoom.zoom-box) up to be a direct child of the upload
  // tab-panel, so the override CSS can position it on the CAPTION ROW (left
  // side) alongside the trash (right side) and the caption (center). The
  // button carries no direct click handler — the lightbox is opened via a
  // delegated handler that still fires anywhere in the document — so relocating
  // it preserves the zoom. Idempotent (no-op once it's a direct child); the
  // engine does not recreate it on background-removal / size changes.
  function ensureZoomInCaptionRow(box) {
    if (!box) return;
    var panel = box.querySelector(':scope > .bsws-tabpanel--upload');
    if (!panel) return;
    var zoom = panel.querySelector('.zoom_image.upload_tools__zoom');
    if (!zoom || zoom.parentElement === panel) return;
    panel.appendChild(zoom);
  }

  // Inject a real divider element between the two switches inside
  // <toggle-options> in the preview-box's footer toolbar. The Image
  // Toolbar handoff (design_handoff_image_toolbar 2026-05-11) has the
  // divider as a flex sibling between the two `.toggle-row` items so
  // the parent's `gap` distributes evenly on both sides and the line
  // sits centered between the two clusters. Engine markup has only
  // the two `.switch` children and no divider, so a CSS pseudo-element
  // can't act as a sibling — inject a `<span class="bsws-toolbar-divider">`
  // so flex treats it as a real third child. Idempotent — no-op if the
  // divider is already in the right place.
  function ensureToolbarDivider(box) {
    if (!box) return;
    var toggles = box.querySelector('.multiupload-rebuild-tools-inner toggle-options');
    if (!toggles) return;
    var first = toggles.querySelector(':scope > .switch.bgRemover');
    var second = toggles.querySelector(':scope > .switch.superRes');
    if (!first || !second) return;
    var existing = toggles.querySelector(':scope > .bsws-toolbar-divider');
    if (existing && existing.previousElementSibling === first && existing.nextElementSibling === second) return;
    if (existing) existing.remove();
    var div = document.createElement('span');
    div.className = 'bsws-toolbar-divider';
    div.setAttribute('aria-hidden', 'true');
    toggles.insertBefore(div, second);
  }

  // Restyle the zoom (magnify) + trash (remove) buttons to match the
  // dtf-transfers reference: 30x30 translucent-black rounded squares with
  // white icons (zoom = white stroked outline, trash = white filled glyph),
  // plus the reference's hover rollover (zoom darkens to rgba(0,0,0,.75) and
  // scales 1.08; trash turns red #DC2626).
  //
  // Everything is set INLINE rather than via CSS because a Yottaa-injected
  // stylesheet rule paint-suppresses our author CSS for a[removefile] —
  // getComputedStyle even mis-reports the background as the old light-gray —
  // so inline !important is the only thing that reliably wins the paint. And
  // because inline base !important would in turn beat any CSS :hover rule, the
  // hover state must ALSO be inline, driven by JS pointer events.
  //
  // The hover listeners are DELEGATED on document (one pair, bound once) rather
  // than per-element: the engine re-renders/relocates these buttons, which
  // would drop per-node mouseenter listeners — and mouseenter/leave don't
  // bubble so they can't be delegated. mouseover/out do bubble. While a control
  // is hovered we tag it (el.__bswsHover) so the periodic re-scan below skips
  // re-applying the resting background/transform (otherwise it would clobber
  // the hover color mid-hover).
  function ensureZoomTrashRefStyle(box) {
    if (!box) return;
    bindZoomTrashHover();
    var BASE = {
      'background': 'rgba(0,0,0,0.4)', 'width': '30px', 'height': '30px',
      'min-width': '30px', 'border': '0', 'border-radius': '8px',
      'display': 'flex', 'align-items': 'center', 'justify-content': 'center',
      'color': '#fff', 'box-shadow': 'none', 'padding': '0', 'transform': 'none'
    };
    function applyBox(el) {
      if (!el) return;
      Object.keys(BASE).forEach(function (k) {
        // Don't stomp the hover color/scale while the pointer is over it.
        if ((k === 'background' || k === 'transform') && el.__bswsHover) return;
        el.style.setProperty(k, BASE[k], 'important');
      });
      el.style.setProperty('transition', 'background .12s ease, transform .12s ease', 'important');
      var svg = el.querySelector('svg');
      if (svg) { svg.style.setProperty('width', '15px', 'important'); svg.style.setProperty('height', '15px', 'important'); }
    }
    applyBox(box.querySelector('.zoom_image.upload_tools__zoom'));
    var trash = box.querySelector('a[removefile]');
    applyBox(trash);
    // Trash icon is a filled glyph — paint it white. (The zoom icon is
    // stroke-based and already white, so its paths are left untouched.)
    if (trash) {
      [].slice.call(trash.querySelectorAll('svg path')).forEach(function (p) {
        p.style.setProperty('fill', '#fff', 'important');
        p.style.setProperty('stroke', 'none', 'important');
      });
    }
  }

  // Force the v3 module's text to Inter (the site's base font). The bysize CSS
  // overrides our own components to "DM Sans"; the rest of the site is Inter, so
  // this realigns them. Done dynamically: scan the loaded stylesheets for any
  // rule whose font-family is DM Sans (all are body.bsws-flow-scoped — ours) and
  // inject ONE Inter override that reuses those exact selectors with an `html`
  // prefix, so it always wins on specificity. Runs from the scan branch but
  // injects only once, and only after ≥1 such rule is found (i.e. the sheets are
  // loaded). Resilient to selector changes and a harmless no-op once the source
  // CSS is updated/purged to Inter. (Yottaa serves stale CSS, so a source edit
  // alone wouldn't take on the live page — hence this runtime override.)
  function ensureInterFont() {
    if (document.getElementById('bsws-inter-font')) return;
    var sels = [];
    for (var i = 0; i < document.styleSheets.length; i++) {
      var rules;
      try { rules = document.styleSheets[i].cssRules; } catch (e) { continue; }
      if (!rules) continue;
      for (var j = 0; j < rules.length; j++) {
        var r = rules[j];
        if (r.selectorText && r.style && r.style.fontFamily && /DM Sans/i.test(r.style.fontFamily)) {
          sels.push(r.selectorText);
        }
      }
    }
    if (!sels.length) return; // sheets not ready / nothing to override yet
    var uniq = [];
    sels.forEach(function (s) { if (uniq.indexOf(s) < 0) uniq.push(s); });
    var over = uniq.map(function (s) {
      return s.split(',').map(function (p) { return 'html ' + p.trim(); }).join(',');
    }).join(',');
    var st = document.createElement('style');
    st.id = 'bsws-inter-font';
    st.textContent = over + '{font-family:Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif !important;}';
    document.head.appendChild(st);
  }

  // v3 PDP single-column (mobile/tablet): put the White-Belt-Cashback crest
  // directly under the checkout CTA, matching dtf-transfers. The source order in
  // the right column is CTA -> BNPL -> Blanks upsell -> cashback, so on a phone
  // the cashback lands far below a tall (often near-empty) Blanks carousel.
  //
  // IMPORTANT: the "Ninja Upsell Block" (grt_upsell_block -> the "Complete your
  // order with Blanks" element) must NOT be touched OR referenced by our code —
  // Owen manages that block entirely in the CMS. So we never style it, reorder
  // it, or query it. We relocate ONLY the cashback crest in the DOM:
  //   • mobile (<=899px, single flex column): move it to right after the dtfut
  //     (whose last child is the checkout CTA) -> cashback sits under the CTA;
  //     everything else keeps its natural source order below it, untouched.
  //   • desktop (>=900px, multi-column): if we'd moved it up on mobile (it's
  //     sitting right after dtfut), send it back to the bottom of the column so
  //     the desktop layout is unchanged. Detected without referencing any other
  //     block, so the CMS-managed upsell is never involved.
  // .product-text/.dtfut are display:contents, so dtfut and the crest are siblings
  // in the same flattened flow -> a plain insertBefore reorders them.
  // Runs every scan tick (covers re-render + resize via the 1s interval). The
  // centering (margin-inline:auto) applies to BNPL + cashback only. Gated to v3.
  function ensureV3CashbackOrder() {
    if (!document.body.classList.contains('template-product-multiupload_vivid_v3')) return;
    // (Centering CSS lives in bysize-v3-single-override.css SECTION J.)
    // Relocate ONLY the cashback crest (upsell block stays untouched).
    var crest = document.querySelector('product-page .reward-point-block.reward-crest') ||
                document.querySelector('product-page .reward-crest');
    var dtfut = document.querySelector('product-page .dtfut');
    if (!crest || !dtfut || dtfut.parentNode !== crest.parentNode) return;
    var parent = crest.parentNode;
    if (window.innerWidth <= 899) {
      if (dtfut.nextElementSibling !== crest) parent.insertBefore(crest, dtfut.nextElementSibling);
    } else if (dtfut.nextElementSibling === crest) {
      // Desktop, and the crest is where our mobile move left it (right after the
      // dtfut) — send it back to the bottom of the column (its natural spot).
      parent.appendChild(crest);
    }
  }

  // While a file is uploading (the big "UPLOADING / Consulting the scrolls"
  // ninja loader is on screen), hide everything ABOVE the loader in the product
  // column — title, reviews, price, "Printed by Ninja", the feature bullets and
  // the Buy-More/Delivery row — so only the loader (and the blocks below it)
  // show. The loader is a <file-progress.fileProgress.ldl> the engine renders
  // only while an upload runs; it lives inside .dtfut, and the header items are
  // the .product-text children BEFORE .dtfut. Detect "uploading" by the loader's
  // RENDERED HEIGHT (not its `hidden` class — that's unreliable pre-upload and
  // previously hid the header before any upload). Hide those header children
  // (inline display:none, tagged for clean reversal) while the loader is up;
  // restore the instant upload finishes. Runs in scan(), which the
  // MutationObserver fires on the upload DOM changes. Gated to the v3 template.
  function ensureUploadHeaderHidden() {
    if (!document.body.classList.contains('template-product-multiupload_vivid_v3')) return;
    var pt = document.querySelector('product-page .product-text');
    var dtfut = document.querySelector('product-page .dtfut');
    if (!pt || !dtfut || dtfut.parentNode !== pt) return;
    var loader = document.querySelector('product-page file-progress.fileProgress.ldl');
    // Gate on the loader's RENDERED HEIGHT, not its `hidden` class: the class is
    // unreliable pre-upload (it can be absent while the loader is still collapsed
    // / empty — which wrongly hid the header before any upload). The engine only
    // renders the ninja card (real height) while an upload is actually running,
    // so height > 0 == "the loader popped" == hide the header.
    var uploading = !!loader && loader.offsetHeight > 20;
    var kids = Array.prototype.slice.call(pt.children);
    var dtIdx = kids.indexOf(dtfut);
    if (dtIdx < 0) return;
    for (var i = 0; i < kids.length; i++) {
      var c = kids[i];
      var hide = uploading && i < dtIdx;
      if (hide) {
        if (c.getAttribute('data-bsws-uphide') !== '1') {
          c.setAttribute('data-bsws-uphide', '1');
          c.style.setProperty('display', 'none', 'important');
        }
      } else if (c.getAttribute('data-bsws-uphide') === '1') {
        c.removeAttribute('data-bsws-uphide');
        c.style.removeProperty('display');
      }
    }
  }

  // Preview caption copy: the engine renders "...print as shown above." but on the
  // v3 layout the image sits BELOW the caption, so swap "above" -> "below". Done by
  // editing the text node only (the bold "Preview:" span is left intact), re-run
  // each scan tick so it survives the engine re-rendering the caption. This script
  // only loads on the v3 template, so it can't touch other products' captions.
  function ensureV3PreviewCaptionBelow() {
    var els = document.querySelectorAll('preview-box .previewText');
    Array.prototype.forEach.call(els, function (el) {
      Array.prototype.forEach.call(el.childNodes, function (n) {
        if (n.nodeType === 3 && /\babove\b/i.test(n.nodeValue)) {
          n.nodeValue = n.nodeValue.replace(/\babove\b/gi, 'below');
        }
      });
    });
  }

  // Size line-item titles are now PURE CSS (2026-06-10 rewrite per Owen):
  // the engine ships native per-item pseudo labels (.widthHeight__item::before
  // content:attr(by), .precut-unit-logic__qty/price/total::before) inside its
  // <=768px media; bysize-v3-single-override.css mirrors those for the
  // container-narrow desktop case. The previous JS-injected label rows
  // (.bsws-precut-hdr / .bsws-wh-hdr) duplicated the engine labels — this now
  // only removes any stray injected rows left in long-lived DOMs.
  function ensureV3LineItemTitles() {
    var stray = document.querySelectorAll('.bsws-precut-hdr, .bsws-wh-hdr');
    Array.prototype.forEach.call(stray, function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  // Sticky-element rail (the rail pattern). WHY a rail exists at all:
  // BUG: as a grid item spanning `grid-row:1/-1`, a sticky card mis-anchors
  // ~300-370px below the grid top at in-between 2-col widths whenever the
  // other column is taller (align-self:start computes but doesn't paint at
  // the area top — engine/Chromium quirk; reflow nudges, margin compensation
  // and auto-item confinement all failed). Pinning to `grid-row:1` fixes the
  // anchor but shrinks the sticky range to row 1, so the card stops following
  // and scrolls away (the empty-left-column bug).
  // FIX: separate the two jobs. A plain injected div (#bsws-preview-rail)
  // is the grid item — a plain block spanning the column anchors at the top
  // correctly (verified) — and the sticky element is adopted INSIDE it, where
  // plain block flow puts it at the rail top and position:sticky/top:148px
  // uses the rail as containing block, giving sticky-follow down the FULL
  // column. `span 60` (not 1/-1) reaches the implicit rows holding the
  // note/precut/checkout tail; surplus empty implicit tracks are 0-height
  // and row-gap is 0, so the tail doesn't move.
  //
  // V3 SWAP (2026-06-12, Owen): the rail's tenant is now PRICES-TABLE — the
  // tier table is the sticky element following the scroll, while the preview
  // card sits INLINE at the top of the right column (grid r1, the slot the
  // table vacated — placement in bysize-v3-single-override.css SECTION H;
  // SECTION B once again cancels the workspace.css preview pin, exactly as
  // it documents). DESKTOP ONLY (>=900px): below 900 .main-product is a flex
  // COLUMN where source order governs — the rail takes the table's DOM slot,
  // so the stack keeps today's order (preview card first, table under it)
  // and nothing pins (the old >=769 preview pin is deleted; its travel inside
  // the shrink-wrapped mobile rail was ~24px — imperceptible). Engine
  // tolerance: the engine WRITES INTO prices-table (per-tier recalc) rather
  // than replacing the node; if it ever replaces it, the re-adopt below picks
  // up the new node next scan tick (same tolerance the preview adoption
  // relied on). Gated to the v3 template + uploaded single mode; the multi
  // modal's preview-boxes/prices-tables (inside multi-upload-wrapper) are
  // never touched.
  function ensureV3PreviewRail() {
    if (!document.body.classList.contains('template-product-multiupload_vivid_v3')) return;
    var b = document.body.classList;
    if (!b.contains('image-uploaded') || b.contains('bsws-multi')) return;
    // page-level single-mode elements only (skip the multi modal's copies)
    var box = null;
    var boxes = document.querySelectorAll('preview-box');
    for (var i = 0; i < boxes.length; i++) {
      if (!boxes[i].closest('multi-upload-wrapper')) { box = boxes[i]; break; }
    }
    if (!box) return;
    var pt = null;
    var pts = document.querySelectorAll('prices-table');
    for (var j = 0; j < pts.length; j++) {
      if (!pts[j].closest('multi-upload-wrapper')) { pt = pts[j]; break; }
    }
    if (!pt) return;
    // (Rail grid placement lives in bysize-v3-single-override.css SECTION J.)
    var rail = document.getElementById('bsws-preview-rail');
    if (!rail) {
      rail = document.createElement('div');
      rail.id = 'bsws-preview-rail';
      // The rail takes the TABLE's DOM slot (not the preview's) so the <900px
      // flex column keeps the pre-swap source order: preview card, then table.
      pt.parentElement.insertBefore(rail, pt);
    }
    // The preview card must NOT live in the rail (it is an inline right-column
    // grid item now). Evacuate it ahead of the rail if a re-render race or a
    // stale page from the pre-swap JS left it inside.
    if (box.parentElement === rail) rail.parentElement.insertBefore(box, rail);
    if (pt.parentElement !== rail) rail.appendChild(pt);
  }

  // Shared "the uploaded workspace can actually paint" check: preview-box has
  // real height and a visible hero img is decoded. Used by the loader bridge
  // (release the overlay) and the below-fold calm (restore the sections).
  function bswsWorkspaceReady() {
    var box = document.querySelector('preview-box');
    if (!box || box.offsetHeight < 100) return false;
    var imgs = box.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].offsetHeight > 50) return !!(imgs[i].complete && imgs[i].naturalWidth > 0);
    }
    return false;
  }

  // Below-fold CLS calm: the upload->workspace swap roughly TRIPLES the height
  // of the product section, shoving every Shopify section below it down the
  // page — measured as ~1.3 of the page's ~1.4 upload-phase CLS (two sections
  // at 0.66 each, shifting twice). Those sections are invisible to the customer
  // during the swap anyway (the bridge overlay covers the viewport), but they
  // still SCORE because rendered boxes moved. Hide them for the upload window
  // (same hide-restore pattern as ensureUploadHeaderHidden) and restore them
  // once the workspace has its final layout — re-appearing at a final position
  // is not a layout shift, so the score (and the real visual jump) disappears.
  // Selector matches the RESIZE-PERF content-visibility set: every section in
  // <main> except the first (the configurator). Restore paths: workspace ready
  // (+bridge released), upload aborted/cancelled, or a 12s safety cap. Runs in
  // scan() (1s tick + mutations). Gated to the v3 template, single mode.
  function ensureV3BelowFoldCalm() {
    if (!document.body.classList.contains('template-product-multiupload_vivid_v3')) return;
    if (document.body.classList.contains('bsws-multi')) return;
    var loader = document.querySelector('product-page file-progress.fileProgress.ldl');
    if (!loader) return;
    var c = window.__bswsCalm || (window.__bswsCalm = { hidden: false, since: 0 });
    var uploading = loader.offsetHeight > 20;
    if (uploading && !c.hidden) {
      // Both the in-main sections AND the trailing footer-group sections after
      // <main> (header sections PRECEDE main, so `main ~` can't catch them).
      var sections = document.querySelectorAll('main > .shopify-section ~ .shopify-section, main ~ .shopify-section');
      Array.prototype.forEach.call(sections, function (el) {
        el.setAttribute('data-bsws-calm', '1');
        el.style.setProperty('display', 'none', 'important');
      });
      c.hidden = true;
      c.since = Date.now();
      return;
    }
    if (c.hidden && !uploading) {
      var settled = bswsWorkspaceReady() && !(window.__bswsBridge && window.__bswsBridge.active);
      var aborted = !document.body.classList.contains('image-uploaded');
      var timedOut = Date.now() - c.since > 12000;
      if (settled || aborted || timedOut) {
        requestAnimationFrame(function () {
          Array.prototype.forEach.call(document.querySelectorAll('[data-bsws-calm="1"]'), function (el) {
            el.removeAttribute('data-bsws-calm');
            el.style.removeProperty('display');
          });
          c.hidden = false;
        });
      }
    }
  }

  // Upload loader bridge: no white screen between the loader and the workspace
  // paint. After a real file upload the engine dismisses the ninja loader as
  // soon as its upload API responds, but the workspace can't paint until the
  // preview image is in and the preview-box lays out (it stays collapsed until
  // then) — measured ~0.3-0.4s of white on fast wifi with a 1MB file; seconds
  // on customer connections with print-size files. Frame-logging showed the
  // engine VISUALLY collapses the loader (offsetHeight 0) ~300ms BEFORE it adds
  // the `hidden` class, and the collapse isn't display-based — so neither the
  // class nor re-forcing display is a usable hook. Instead: detect the VISUAL
  // collapse (offsetHeight <= 20 after the loader was genuinely shown this
  // cycle) while the workspace isn't paint-ready, and mount our own fixed
  // overlay (spinner + "Preparing your preview…") for exactly that gap. An rAF
  // watcher removes it one painted frame after the preview-box has real height
  // and a visible hero img is decoded; hard 8s cap so a failed image can never
  // trap the overlay. seenVisible arming means page-load restores and the
  // instant previous-designs path (loader never collapses while unready) are
  // untouched. Gated to the v3 template, single mode.
  function ensureV3LoaderBridge() {
    if (!document.body.classList.contains('template-product-multiupload_vivid_v3')) return;
    if (document.body.classList.contains('bsws-multi')) return;
    var loader = document.querySelector('product-page file-progress.fileProgress.ldl');
    if (!loader) return;
    var b = window.__bswsBridge || (window.__bswsBridge = { active: false, since: 0, seenVisible: false, workspaceSeen: false });
    var visible = loader.offsetHeight > 20;
    if (!document.body.classList.contains('image-uploaded') && !visible && !b.active) {
      // fully back to pre-upload — re-arm for the next cycle
      b.seenVisible = false;
      b.workspaceSeen = false;
    }
    if (visible && !b.active) b.seenVisible = true;
    if (b.active) return; // watcher below owns the release
    var ready = bswsWorkspaceReady;
    // Once the uploaded workspace has painted, the bridge's job is done for
    // this upload cycle. Engine RE-processing (Remove Background / Upscale)
    // re-shows the loader and briefly swaps the hero img (ready() dips false)
    // — that must NOT re-veil the page with the white overlay (Owen
    // 2026-06-12: BG remove was flashing/holding a white screen for up to the
    // 8s cap). The bridge covers ONLY the initial upload->workspace swap; a
    // workspace->workspace re-render causes no layout swap worth veiling.
    if (document.body.classList.contains('image-uploaded') && ready()) {
      b.workspaceSeen = true;
    }
    if (b.seenVisible &&
        !visible &&
        !b.workspaceSeen &&
        document.body.classList.contains('image-uploaded') &&
        !ready()) {
      b.active = true;
      b.since = Date.now();
      // (Overlay styles live in bysize-v3-single-override.css SECTION J.)
      var ov = document.getElementById('bsws-upload-bridge');
      if (!ov) {
        ov = document.createElement('div');
        ov.id = 'bsws-upload-bridge';
        var card = document.createElement('div');
        card.className = 'bsws-bridge-card';
        var spin = document.createElement('div');
        spin.className = 'bsws-bridge-spin';
        var txt = document.createElement('div');
        txt.className = 'bsws-bridge-txt';
        txt.textContent = 'Preparing your preview…';
        card.appendChild(spin);
        card.appendChild(txt);
        ov.appendChild(card);
        document.body.appendChild(ov);
      }
      ov.style.display = 'flex';
      (function watch() {
        var s2 = window.__bswsBridge;
        if (!s2 || !s2.active) return;
        if (ready() || Date.now() - s2.since > 8000) {
          // one more painted frame with the hero on screen, then drop the veil
          requestAnimationFrame(function () {
            var o = document.getElementById('bsws-upload-bridge');
            if (o) o.style.display = 'none';
            s2.active = false;
            s2.seenVisible = false;
          });
          return;
        }
        requestAnimationFrame(watch);
      })();
    }
  }

  // Remove every style block we inject for the single-mode v3 layout. Called
  // from the multi-upload branch so none of our single-mode restyling leaks into
  // the multi flow. Each injector is id-guarded, so they cleanly re-inject when
  // the flow returns to single mode.
  function clearSingleModeStyleInjections() {
    ['bsws-note-precut-css', 'bsws-inter-font'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.remove();
    });
  }

  // Document-delegated hover rollover for the zoom + trash buttons. Bound once.
  // mouseover/out bubble, so a single pair of document listeners keeps working
  // across engine re-renders of the buttons (per-node listeners would be lost).
  function bindZoomTrashHover() {
    if (window.__bswsZtHoverBound) return;
    window.__bswsZtHoverBound = true;
    var ZOOM_SEL = '.zoom_image.upload_tools__zoom', TRASH_SEL = 'a[removefile]';
    function hit(target) {
      // Single-mode uploaded only — don't let the rollover touch the multi-
      // upload modal (which carries neither bsws-flow nor image-uploaded) or any
      // other state. The base zoom/trash restyle only exists there anyway.
      var b = document.body.classList;
      if (!b.contains('bsws-flow') || !b.contains('image-uploaded') || b.contains('bsws-multi')) return null;
      if (!target || !target.closest) return null;
      var z = target.closest(ZOOM_SEL); if (z) return { el: z, bg: 'rgba(0,0,0,0.75)', tf: 'scale(1.08)' };
      var t = target.closest(TRASH_SEL); if (t) return { el: t, bg: '#DC2626', tf: 'scale(1.08)' };
      return null;
    }
    document.addEventListener('mouseover', function (e) {
      var h = hit(e.target); if (!h) return;
      h.el.__bswsHover = true;
      h.el.style.setProperty('background', h.bg, 'important');
      h.el.style.setProperty('transform', h.tf || 'none', 'important');
    });
    document.addEventListener('mouseout', function (e) {
      var h = hit(e.target); if (!h) return;
      // Ignore moves to a descendant of the same control (not a real leave).
      if (e.relatedTarget && h.el.contains(e.relatedTarget)) return;
      h.el.__bswsHover = false;
      h.el.style.setProperty('background', 'rgba(0,0,0,0.4)', 'important');
      h.el.style.setProperty('transform', 'none', 'important');
    });
  }

  // Single mode: the engine sizes the uploaded preview ONCE — the image plus
  // its three dimension-ruler pieces (.horizontal_direction, .verticle_direction,
  // .upload_tools) — to a fit-to-padded-body size, and never recomputes (it
  // ignores resize). That leaves the preview small with large margins. We grow
  // it to the maximum UNDISTORTED area of the body, PRESERVING the print's
  // aspect ratio (width/height) — the design can be square (6.67x6.67) OR a wide
  // banner (6.67x2.33) OR tall, so we must fit a rectangle of the image's own
  // aspect, never a forced square (that was a bug that stretched the box for
  // non-square prints). The engine pins the size via !important rules (class +
  // #id selectors), so plain CSS can't beat it — we set the assembly's size
  // inline (highest priority). All four pieces scale together so the rulers stay
  // aligned to the image. Clearance is reserved on the TOP (top ruler/label vs
  // the "Preview:" caption) and LEFT (left ruler/label vs the body edge / zoom
  // icon) since the rulers extend above and left of the image. A ResizeObserver
  // re-runs it on body resize (the scan observer only fires on re-render).
  function ensurePreviewMaxSize(box) {
    if (!box) return;
    var panel = box.querySelector(':scope > .bsws-tabpanel--upload');
    if (!panel) return;
    var fp = panel.querySelector('file-preview');
    var zb = panel.querySelector('.zoom-box');
    if (!fp || !zb) return;
    var img = zb.querySelector('img.fileupload_hero');
    if (!img) return;
    var hd = zb.querySelector('.horizontal_direction');
    var vd = zb.querySelector('.verticle_direction');
    var ut = zb.querySelector('.upload_tools');
    // Need the image's natural size to know the aspect ratio. If it hasn't
    // loaded yet, wait for it and re-run (the scan can fire before load).
    if (!img.naturalWidth || !img.naturalHeight) {
      if (!img.dataset.bswsAwaitLoad) {
        img.dataset.bswsAwaitLoad = '1';
        img.addEventListener('load', function () {
          img.removeAttribute('data-bsws-await-load');
          ensurePreviewMaxSize(box);
        }, { once: true });
      }
      return;
    }
    // Treat the image AND its measurements as ONE unit for placement/padding.
    // The rulers + labels extend BEYOND the image: the top ruler + "6.67" label
    // ~25px ABOVE, the left ruler + "2.33" label ~26px to the LEFT, ~2px right,
    // ~0 below. We want that whole assembly centered in the body with a uniform
    // PAD all around — so the body padding carries PAD *plus* the one-sided
    // measurement overhang on each edge. That shifts the (flex-centered) image
    // just enough that the ASSEMBLY — not the bare image — is what ends up
    // centered, with equal PAD gaps to the body edges. (Also keeps the top ruler
    // clear of the "Preview:" caption and the left ruler off the body edge.)
    var PAD = 12;
    var OH_TOP = 25, OH_LEFT = 26, OH_RIGHT = 2, OH_BOTTOM = 0; // measurement overhang past the image
    var padT = PAD + OH_TOP, padB = 2 + OH_BOTTOM, padL = PAD + OH_LEFT, padR = PAD + OH_RIGHT; // bottom gap reduced to 2px per design
    fp.style.setProperty('padding', padT + 'px ' + padR + 'px ' + padB + 'px ' + padL + 'px', 'important');
    var availW = fp.clientWidth - padL - padR;
    var availH = fp.clientHeight - padT - padB;
    if (availW < 40 || availH < 40) return; // not laid out yet
    // Fit the largest rectangle of the image's aspect ratio into the available
    // area — width-limited for wide prints, height-limited for tall/square.
    var aspect = img.naturalWidth / img.naturalHeight; // width / height
    var w, h;
    if (availW / availH > aspect) { h = availH; w = Math.round(h * aspect); }
    else { w = availW; h = Math.round(w / aspect); }
    var key = w + 'x' + h;
    if (zb.dataset.bswsMaxedTo !== key) {
      [zb, img].forEach(function (el) {
        el.style.setProperty('width', w + 'px', 'important');
        el.style.setProperty('height', h + 'px', 'important');
        el.style.setProperty('max-width', 'none', 'important');
        el.style.setProperty('max-height', 'none', 'important');
      });
      if (hd) hd.style.setProperty('width', w + 'px', 'important');  // top ruler line
      if (vd) vd.style.setProperty('height', h + 'px', 'important'); // left ruler line
      if (ut) ut.style.setProperty('width', w + 'px', 'important');  // top label bar
      zb.dataset.bswsMaxedTo = key;
    }
    // Re-run on body resize. Guarded so only one observer is ever attached.
    if (!fp.dataset.bswsMaxObserver && typeof ResizeObserver !== 'undefined') {
      fp.dataset.bswsMaxObserver = '1';
      var ro = new ResizeObserver(function () {
        var z = panel.querySelector('.zoom-box');
        if (z) z.dataset.bswsMaxedTo = ''; // force recompute for the new size
        ensurePreviewMaxSize(box);
      });
      ro.observe(fp);
    }
  }

  // Restyle the design-note + pre-cut cards into the new matching format:
  // [checkbox] · bold title / gray subtitle (pre-cut keeps an ⓘ pushed to the
  // far right). Done via JS (DOM text + an injected <style>) because the text
  // is engine/snippet-rendered and the CSS file is Yottaa-cached. The note's
  // existing click-to-expand (data-collapsed) and the pre-cut's real checkbox
  // are reused — checking either reveals its content (note → textarea with its
  // placeholder). Idempotent (id + dataset guards). NOTE: when the Yottaa cache
  // is fixed, fold the note markup/CSS back into snippets/nt-design-note.liquid.
  function ensureNotePrecutRestyle(box) {
    if (!box) return;
    if (!document.getElementById('bsws-note-precut-css')) {
      var st = document.createElement('style');
      st.id = 'bsws-note-precut-css';
      st.textContent = [
        // -- Note box: pencil icon -> checkbox look (checked when expanded) --
        'body.bsws-flow.image-uploaded .nt-design-note__icon{width:20px!important;height:20px!important;border:1.5px solid #cfd4da!important;border-radius:6px!important;background:#fff!important;display:grid!important;place-items:center!important;padding:0!important;}',
        'body.bsws-flow.image-uploaded .nt-design-note__icon svg{display:none!important;}',
        'body.bsws-flow.image-uploaded .nt-design-note[data-collapsed="false"] .nt-design-note__icon{background:#3ba3f2!important;border-color:#3ba3f2!important;}',
        'body.bsws-flow.image-uploaded .nt-design-note[data-collapsed="false"] .nt-design-note__icon::after{content:""!important;display:block;width:5px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);margin-top:-1px;}',
        'body.bsws-flow.image-uploaded .nt-design-note__chevron{display:none!important;}',
        // Note header mirrors the pre-cut GRID row (Owen 2026-06-12: subtitle
        // baselines of the two cards must match — same 20px row 1, same 4px
        // row-gap, same per-row centering, so geometry is equal BY
        // CONSTRUCTION, not by pixel nudge). cols: icon / title(1fr) / chevron.
        'body.bsws-flow.image-uploaded .nt-design-note__header{display:grid!important;grid-template-columns:20px minmax(0,1fr) auto!important;column-gap:10px!important;row-gap:4px!important;align-items:center!important;}',
        'body.bsws-flow.image-uploaded .nt-design-note__title{display:contents!important;}',
        'body.bsws-flow.image-uploaded .nt-design-note__title strong{font-weight:700!important;font-size:14px!important;color:#111!important;line-height:1.2!important;}',
        'body.bsws-flow.image-uploaded .nt-design-note__sub{color:#1f2328!important;font-size:12px!important;font-weight:400!important;line-height:1.2!important;grid-column:2 / -1!important;grid-row:2!important;}',
        // -- Pre-cut box: GRID row (Owen 2026-06-12) — the subtitle must sit on
        // ONE line, which the old flex layout could not give: the label column
        // was squeezed by the checked-state $/each chip + ⓘ and the subtitle
        // either truncated (engine nowrap+hidden) or wrapped to two lines.
        // Grid + display:contents on the label lets title and subtitle place
        // independently: row 1 = checkbox / title(1fr) / chip / ⓘ; row 2 =
        // subtitle spanning cols 2..end (full card width, ~309px at the 2-up
        // card — the text needs ~225px). align-items:center centers each row-1
        // item on the title line (chip + ⓘ ride it, checkbox aligns with it).
        'body.bsws-flow.image-uploaded precut.bsws-flow__precut .precut__row{display:grid!important;grid-template-columns:20px minmax(0,1fr) auto auto!important;column-gap:10px!important;row-gap:4px!important;align-items:center!important;width:100%!important;}',
        // Match the pre-cut real checkbox to the note checkbox: 24px, 6px radius,
        // 1.5px border, white→#3ba3f2 when checked, white tick. (.bsws-flow__precut
        // bumps specificity so it beats the engine 20px rule.)
        'body.bsws-flow.image-uploaded precut.bsws-flow__precut input[type=checkbox]{appearance:none!important;-webkit-appearance:none!important;width:20px!important;height:20px!important;min-width:20px!important;border:1.5px solid #cfd4da!important;border-radius:6px!important;background:#fff!important;position:relative!important;margin:0!important;padding:0!important;flex:0 0 auto!important;cursor:pointer!important;box-shadow:none!important;}',
        'body.bsws-flow.image-uploaded precut.bsws-flow__precut input[type=checkbox]:checked{background:#3ba3f2!important;border-color:#3ba3f2!important;}',
        'body.bsws-flow.image-uploaded precut.bsws-flow__precut input[type=checkbox]:checked::before{display:none!important;}',
        'body.bsws-flow.image-uploaded precut.bsws-flow__precut input[type=checkbox]:checked::after{content:""!important;position:absolute!important;left:6px!important;top:3px!important;width:5px!important;height:9px!important;border:solid #fff!important;border-width:0 2px 2px 0!important;transform:rotate(45deg)!important;background:none!important;}',
        // label dissolves into the row grid; its old gap/line-height move to
        // the children (display:contents elements generate no box).
        'body.bsws-flow.image-uploaded precut .precut__label{display:contents!important;}',
        'body.bsws-flow.image-uploaded precut .precut__label strong{font-weight:700!important;font-size:14px!important;color:#111!important;display:block!important;line-height:1.2!important;}',
        // subtitle: ONE line on row 2 spanning the full card width; the engine
        // label's nowrap would otherwise inherit, so re-set normal here.
        'body.bsws-flow.image-uploaded precut .bsws-precut-sub{color:#1f2328!important;font-size:12px!important;font-weight:400!important;line-height:1.2!important;white-space:normal!important;grid-column:2 / -1!important;grid-row:2!important;}',
        'body.bsws-flow.image-uploaded precut .precut__info{margin-left:auto!important;flex:0 0 auto!important;}',
        // -- Inner padding (the old align-items:flex-start header rule is gone:
        //    the grid header above centers each item within ITS row, which is
        //    what keeps the checkbox/icon on line 1) --
        'body.bsws-flow.image-uploaded .nt-design-note{padding:13px 16px!important;height:auto!important;justify-content:flex-start!important;}',
        'body.bsws-flow.image-uploaded .nt-design-note[data-collapsed="false"]{padding:13px 16px!important;}',
        'body.bsws-flow.image-uploaded precut.bsws-flow__precut{padding:13px 16px!important;height:auto!important;min-height:0!important;}'
      ].join('');
      document.head.appendChild(st);
    }
    // Note box copy (lives in the right column, not inside the preview-box, so
    // query the document — same as the pre-cut lookup below).
    var note = box.querySelector('.nt-design-note') || document.querySelector('.nt-design-note');
    if (note && note.dataset.bswsNoteText !== '1') {
      var nStrong = note.querySelector('.nt-design-note__title strong');
      var nSub = note.querySelector('.nt-design-note__sub');
      if (nStrong) nStrong.textContent = 'Add Free design notes (optional)';
      if (nSub) nSub.textContent = 'Request changes from our designers';
      note.dataset.bswsNoteText = '1';
    }
    // Pre-cut box copy + layout
    var pc = box.querySelector('precut') || document.querySelector('precut.bsws-flow__precut');
    if (pc && pc.dataset.bswsPrecutText !== '1') {
      var pStrong = pc.querySelector('.precut__label strong');
      if (pStrong) pStrong.textContent = 'Pre-cut my transfers';
      var label = pc.querySelector('.precut__label');
      if (label) {
        [].slice.call(label.childNodes).forEach(function (n) {
          if (n.nodeType === 3 && /Pre-?cut transfers/i.test(n.textContent)) {
            var sub = document.createElement('span');
            sub.className = 'bsws-precut-sub';
            sub.textContent = 'Save time with individually cut transfers';
            // The engine forces the pre-cut label text to 600 via a higher-
            // priority rule; set the regular weight inline (!important) so the
            // subtitle is truly 400 like the note subtitle.
            sub.style.setProperty('font-weight', '400', 'important');
            label.replaceChild(sub, n);
          }
        });
      }
      var info = pc.querySelector('.precut__info');
      var row = pc.querySelector('.precut__row');
      if (info && row && info.parentElement !== row) row.appendChild(info);
      pc.dataset.bswsPrecutText = '1';
    }
  }

  // Move (don't clone) the page's single .dtf_imgix_images element into
  // the guide panel of the given preview-box. Idempotent — no-op if it's
  // already there. Engine's global selectors keep matching the single
  // moved instance.
  function attachSizeGuide(box) {
    if (!box) return;
    var guidePanel = box.querySelector(':scope > .bsws-tabpanel--guide');
    if (!guidePanel) return;
    var sizeGuide = document.querySelector('.dtf_imgix_images');
    if (!sizeGuide) return;
    if (sizeGuide.parentNode === guidePanel) return;
    guidePanel.appendChild(sizeGuide);
  }

  // Move the size guide out of a block that's about to be deleted, so it
  // isn't destroyed alongside the block. Parking spot: `<body>` (kept
  // hidden via the parent block's removal — once detached from the block,
  // it's a body-level orphan until our next scan calls attachSizeGuide on
  // a different block's guide panel). Idempotent — no-op if the block
  // doesn't contain the guide.
  function parkSizeGuideFromBlock(block) {
    if (!block) return;
    var sg = block.querySelector('.dtf_imgix_images');
    if (sg) document.body.appendChild(sg);
  }

  // Move the reward block ("Earn up to $X back") so it sits below Proceed
  // to Checkout in both modes. The engine renders it once at
  // `<next-element><div id="product_reward-point-block">` inside the legacy
  // single-upload chain. In multi mode `.main-product { display:none }`
  // hides the entire chain, so the reward never paints without
  // intervention. The element is a singleton tied to total cart value (the
  // engine updates it by ID), so a single instance correctly reflects all
  // designs in multi.
  //
  // - Multi: append to `.multiUpload__inner__wrapper` (the grid container).
  //   CSS places it at grid-row: 9, grid-column: -2 — directly below
  //   proceed-to-checkout at row 8.
  // - Single: restore to its original `<next-element>` parent so Layer A's
  //   display:contents flattening puts it back in the .main-product grid;
  //   same row-9 placement applies.
  //
  // Original parent is captured on first encounter so teardown can restore
  // exactly. Idempotent — no-op if already in the right place.
  var rewardOriginalParent = null;
  function ensureRewardPlacement(wrapper) {
    var reward = document.getElementById('product_reward-point-block');
    if (!reward) return;
    if (!rewardOriginalParent && reward.parentNode) {
      rewardOriginalParent = reward.parentNode;
    }
    var multi = document.body.classList.contains('bsws-multi');
    if (multi) {
      var grid = (wrapper && wrapper.querySelector('.multiUpload__inner__wrapper')) ||
                 document.querySelector('.multiUpload__inner__wrapper');
      if (grid && reward.parentNode !== grid) {
        grid.appendChild(reward);
      }
    } else if (rewardOriginalParent && reward.parentNode !== rewardOriginalParent) {
      rewardOriginalParent.appendChild(reward);
    }
  }

  // Force the engine's reward calculator to re-sum across all designs.
  //
  // The reward display ("Earn up to $X back") is driven by
  // `snippets/reward-point-info.liquid` — its `_qtyupdate()` iterates
  // `.precut-unit-logic__total .__discountedPrice` across the entire
  // document and stamps the result into `#__reward_info`. The selector
  // already crosses all uploaded-files-block instances (visibility doesn't
  // affect querySelectorAll), so the math is correct as long as the
  // function actually runs.
  //
  // What's missing: the engine only calls `_qtyupdate()` from input/click
  // handlers on the currently-visible qty field. Rail-tile selection
  // changes (workspace.js-driven) and the initial multi entry don't touch
  // any of those handlers, so the displayed reward stays stuck at whatever
  // value was computed at first paint (often from a single block before
  // the user uploaded the second design).
  //
  // We call `_qtyupdate()` ourselves on every scan tick (cheap — pure
  // arithmetic over a handful of nodes) and on selection change to keep
  // the displayed total in sync with the current set of designs.
  function refreshMultiReward() {
    if (typeof window._qtyupdate === 'function') {
      try { window._qtyupdate(); } catch (e) { /* engine sometimes pre-init */ }
    }
  }

  // Multi-upload loading overlay. While any block is still processing
  // (no hero loaded yet, or engine's per-block <file-progress> hasn't
  // received `.hidden`), surface a single full-coverage running-ninja
  // card on top of the multi workspace — matches the single-mode upload
  // experience instead of letting the user see the messy intermediate
  // state (empty preview, oversized trash icon, "Custom Size" tabs
  // floating in a blank column, etc.) while the engine builds out per-
  // block markup.
  //
  // Strategy: inject one `<file-progress class="fileProgress
  // bsws-multi-overlay">` element with the engine's exact markup
  // structure as a direct child of `.multiUpload__inner__wrapper`.
  // Engine CSS automatically styles `.fileProgress__ninjaImg`,
  // `__msg`, `__loadingPercent`, `__barWrap` so we get the same visuals
  // as single. CSS in workspace.css positions it absolute fill via
  // `body.bsws-multi-loading`, and hides messy children during that
  // window.
  //
  // Toggle is observation-based: any block that lacks a loaded hero
  // (`naturalWidth > 0` and src not the transparent placeholder), OR
  // has a file-progress without `.hidden`, counts as "processing".
  function ensureMultiUploadOverlay(wrapper) {
    if (!wrapper) return;
    // Place the loader INSIDE single's `.product-text` (right column
     // of .main-product). product-text already contains title, stars,
     // features, Buy-More-Save, then the workspace controls — append
     // overlay at the END so it sits below all the product info
     // exactly like single's loader sits below Buy-More. CSS during
     // multi-loading display:none's the workspace controls so they
     // collapse and the overlay appears right under Buy-More.
    var productText = document.querySelector('.main-product .product-text, section.main-product .product-text');
    if (!productText) return;
    // Look for the wrapper we injected previously (we wrap the file-
    // progress in `.only_progressBar` so engine CSS at bySize.css:2242
    // (`.only_progressBar .fileProgress`) activates and styles the
    // overlay identically to single's loader.
    var overlay = productText.querySelector(':scope > .only_progressBar.bsws-multi-overlay-wrap');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'only_progressBar bsws-multi-overlay-wrap';
      overlay.setAttribute('data-bsws-injected', '1');
      // Markup copied verbatim from snippets/__multipleSnippets.liquid:
      // 1090-1106 — the engine's single-mode `only_progressBar`
      // structure. Using identical markup means engine CSS handles all
      // styling — overlay is visually pixel-identical to single's
      // loader without any custom CSS.
      overlay.innerHTML =
        '<file-progress class="fileProgress bsws-multi-overlay">' +
          '<img src="https://cdn.shopify.com/s/files/1/0558/0265/8899/files/Ninja-Running-Loop-200x-200-cleaned.gif?v=1758717834" class="fileProgress__ninjaImg">' +
          '<div class="fileProgress__loadingPercent">' +
            '<span class="loadingPercent__counter">0%</span>' +
          '</div>' +
          '<div class="fileProgress__barWrap">' +
            '<span class="fileProgress__bar" style="width: 0%;">' +
              '<img src="https://cdn.shopify.com/s/files/1/0558/0265/8899/files/New_Ball.png?auto=format,compress&amp;v=1734081591">' +
            '</span>' +
          '</div>' +
          '<p>We&#39;re making sure your upload is perfect for printing.<br>This may take a few seconds.</p>' +
          '<a href="javascript://" style="color: #03a3f7; cursor: pointer;">Stop</a>' +
        '</file-progress>';
      productText.appendChild(overlay);
    }

    var blocks = wrapper.querySelectorAll('uploaded-files-block');
    var anyProcessing = false;
    Array.prototype.forEach.call(blocks, function (b) {
      if (anyProcessing) return;
      var hero = b.querySelector('.fileupload_hero');
      var heroSrc = (hero && hero.src) || '';
      var heroLoaded = hero && hero.naturalWidth > 0 && heroSrc.indexOf('transparent') === -1;
      var fp = b.querySelector('file-progress');
      var fpActive = fp && !fp.classList.contains('hidden') && !fp.classList.contains('bsws-multi-overlay');
      // Also wait for fixMultiBlockDimensions to finish — vector / PDF
      // files take an async API roundtrip and the row briefly carries
      // engine's bogus 0.28" dimensions + an orange DPI warning until
      // we replace them. Keep the loading overlay up until that's done.
      var dimsFixed = b.dataset.bswsDimFixed === '1';
      if (!heroLoaded || fpActive || !dimsFixed) anyProcessing = true;
    });
    var loading = anyProcessing && blocks.length > 0;
    var wasLoading = document.body.classList.contains('bsws-multi-loading');
    document.body.classList.toggle('bsws-multi-loading', loading);

    // Fake-animate the counter & bar from 0% → ~95% while loading.
    // Single mode's counter is engine-driven (real upload progress);
    // we don't have a clean signal in multi without hooking the engine
    // per-block progress callbacks, so a steady ease-out animation
    // matches the visual cadence without overpromising completion.
    if (loading && !wasLoading) {
      var startTs = Date.now();
      var counter = overlay.querySelector('.loadingPercent__counter');
      var bar = overlay.querySelector('.fileProgress__bar');
      if (overlay._bswsCounterTimer) clearInterval(overlay._bswsCounterTimer);
      overlay._bswsCounterTimer = setInterval(function () {
        if (!document.body.classList.contains('bsws-multi-loading')) {
          clearInterval(overlay._bswsCounterTimer);
          return;
        }
        var elapsed = Date.now() - startTs;
        var t = Math.min(elapsed / 3500, 1);
        var eased = 1 - Math.pow(1 - t, 2);
        var pct = Math.round(eased * 95);
        if (counter) counter.textContent = pct + '%';
        if (bar) bar.style.width = pct + '%';
      }, 60);
    }
  }

  // Refresh size-guide labels + watermark to reflect the currently-
  // selected block in multi mode.
  //
  // The engine's multi-mode calculateratioForImage()
  // (pdp_transferBySize-multiupload.js:2611) and watermark setter
  // (:3822) both read globally — `document.querySelector('.widthHeight
  // __value[name="width__value"]')` returns the FIRST match in document
  // order, which is the first block's input, not the selected block's.
  // Same for the watermark — it writes whatever was most recently
  // uploaded, not the selected design. So when a user switches rail
  // tiles, the size guide stays stuck on whatever the engine wrote
  // last.
  //
  // Workspace-side fix: read width/height/hero from the SELECTED block
  // and re-write each slot label. Each slot's maxW × maxH pair is copied
  // from the engine source. Watermark img src is set to the selected
  // block's .fileupload_hero (the engine's own per-block preview image).
  //
  // We deliberately do NOT call the engine's `getRadioMaintainImg` for
  // the math, even though it computes the same shape — that helper
  // funnels through `ratioBy()` (bySize_popular.js:5659) which reads
  // GLOBAL `ratio_width` / `ratio_height` vars instead of the parameters
  // it's given. Result: switching rail tiles in multi mode left every
  // block's labels showing the FIRST upload's aspect ratio, because the
  // globals were only ever set once. Computing aspect locally from the
  // selected block's hero `naturalWidth/naturalHeight` is per-block-
  // correct and doesn't rely on any engine global.
  var SIZE_GUIDE_SLOTS = [
    { sel: '._first',  maxW: 11,  maxH: 20  },
    { sel: '._second', maxW: 5,   maxH: 2.5 },
    { sel: '._third',  maxW: 3.5, maxH: 6   },
    { sel: '._forth',  maxW: 7,   maxH: 9   },
    { sel: '._fifth',  maxW: 11,  maxH: 9   },
    { sel: '._sixth',  maxW: 5,   maxH: 10  }
  ];
  // Constrain (w, h) of the design into a slot's (maxW, maxH) box,
  // preserving the design's aspect ratio. Returns the design's final
  // width × height as a "11.00\" x 8.92\"" formatted string.
  function fitToSlot(aspect, maxW, maxH) {
    // aspect = designWidth / designHeight
    // Try filling width first: if resulting height fits, use it.
    var widthIfMaxW  = maxW;
    var heightIfMaxW = maxW / aspect;
    if (heightIfMaxW <= maxH) {
      return widthIfMaxW.toFixed(2) + '" x ' + heightIfMaxW.toFixed(2) + '"';
    }
    // Otherwise constrained by height:
    var heightIfMaxH = maxH;
    var widthIfMaxH  = maxH * aspect;
    return widthIfMaxH.toFixed(2) + '" x ' + heightIfMaxH.toFixed(2) + '"';
  }
  function refreshSizeGuideForSelectedBlock(wrapper) {
    if (!wrapper) wrapper = document.querySelector('multi-upload-wrapper');
    if (!wrapper) return;
    var selBlock = wrapper.querySelector('uploaded-files-block.bsws-selected');
    if (!selBlock) return;
    var hero = selBlock.querySelector('.fileupload_hero');
    // Aspect source: prefer hero naturalWidth/naturalHeight (always per-
    // block correct as soon as the image loads). Fallback to input W/H
    // only if hero hasn't loaded yet — input values are also per-block
    // correct in multi but may be blank for non-first blocks until the
    // user interacts.
    var aspect = NaN;
    if (hero && hero.naturalWidth && hero.naturalHeight) {
      aspect = hero.naturalWidth / hero.naturalHeight;
    } else {
      var wEl = selBlock.querySelector('.widthHeight__value[name="width__value"]');
      var hEl = selBlock.querySelector('.widthHeight__value[name="height__value"]');
      var w = wEl ? parseFloat(wEl.value) : NaN;
      var h = hEl ? parseFloat(hEl.value) : NaN;
      if (w > 0 && h > 0) aspect = w / h;
    }
    if (aspect > 0) {
      SIZE_GUIDE_SLOTS.forEach(function (s) {
        var span = document.querySelector('.dtf_body_image ' + s.sel + ' span');
        if (!span) return;
        span.innerHTML = fitToSlot(aspect, s.maxW, s.maxH);
      });
    }
    // Watermark: write the selected block's hero image to every size-
    // guide slot AND set the wrapper's opacity to 1 (baseline is opacity
    // 0 from product-gallery.liquid:501-509; engine normally sets it to
    // 1 via $(".watermark_image").css("opacity",1) in pdp_transferBySize
    // -multiupload.js:3821 but only during its own upload pipeline, not
    // on rail-tile switch). Skip if hero hasn't loaded yet.
    var heroSrc = (hero && hero.src) || '';
    if (heroSrc && heroSrc.indexOf('transparent.png') === -1) {
      var wms = document.querySelectorAll('.dtf_body_image .watermark_image img');
      Array.prototype.forEach.call(wms, function (img) {
        if (img.src !== heroSrc) img.src = heroSrc;
      });
      var wrappers = document.querySelectorAll('.dtf_body_image .watermark_image');
      Array.prototype.forEach.call(wrappers, function (wrap) {
        wrap.style.opacity = '1';
      });
    }
    // Labels: same opacity-0-baseline trap as watermarks. Engine drops
    // them to 0 in bySize_popular.js:3884 during upload init and only
    // raises to 1 in :5858 at the end of a successful single-mode flow.
    // In multi mode that "raise to 1" doesn't fire on rail-tile switch,
    // so we set it here whenever we have a valid block to show.
    var labels = document.querySelectorAll('.dtf_body_image .dtf_body_image_labels');
    Array.prototype.forEach.call(labels, function (l) {
      l.style.opacity = '1';
    });
  }

  // One-time delegated click handler for tab buttons. Sets the active tab
  // attribute on <body>; CSS handles panel visibility.
  function attachPreviewTabClickHandler() {
    if (window._bswsPreviewTabsAttached) return;
    window._bswsPreviewTabsAttached = true;
    // Initialize default — Your Upload — if not yet set.
    if (!document.body.dataset.bswsPreviewTab) {
      document.body.dataset.bswsPreviewTab = 'upload';
    }
    document.body.addEventListener('click', function (e) {
      var tab = e.target && e.target.closest && e.target.closest('.bsws-tab[data-bsws-tab]');
      if (!tab) return;
      e.preventDefault();
      var which = tab.dataset.bswsTab;
      if (which !== 'upload' && which !== 'guide') return;
      document.body.dataset.bswsPreviewTab = which;
      // Sync the .is-active class on every tab button across all preview-
      // boxes (covers per-block tabs in multi mode).
      var allTabs = document.querySelectorAll('.bsws-tab[data-bsws-tab]');
      Array.prototype.forEach.call(allTabs, function (t) {
        t.classList.toggle('is-active', t.dataset.bswsTab === which);
      });
    });
  }

  // Sync .is-active on tab buttons inside a specific box based on body's
  // current active-tab attribute. Used after injecting tabs into a new
  // preview-box (e.g., on first scan or when a new block appears).
  function syncPreviewTabsState(box) {
    if (!box) return;
    var active = document.body.dataset.bswsPreviewTab || 'upload';
    var tabs = box.querySelectorAll(':scope > .bsws-tabs .bsws-tab');
    Array.prototype.forEach.call(tabs, function (t) {
      t.classList.toggle('is-active', t.dataset.bswsTab === active);
    });
  }

  // Find the currently-relevant preview-box: in multi mode it's inside
  // the selected uploaded-files-block; in single mode it's the engine's
  // single preview-box. Returns null if not present yet.
  function getActivePreviewBox(wrapper) {
    if (document.body.classList.contains('bsws-multi')) {
      var selBlock = (wrapper || document).querySelector('uploaded-files-block.bsws-selected');
      if (selBlock) return selBlock.querySelector('preview-box');
      return null;
    }
    return document.querySelector('upload-controls preview-box, preview-box');
  }

  function ensureRail(wrapper) {
    var inner = wrapper.querySelector('.multiUpload__inner__wrapper, .__multiUpload__inner__wrapper');
    if (!inner) return;
    if (rail && rail.parentNode === inner) return;
    rail = document.createElement('aside');
    rail.className = 'bsws-rail';
    rail.setAttribute('aria-label', 'Your uploads');
    rail.innerHTML = '<div class="bsws-rail__title">YOUR UPLOADS</div><div class="bsws-rail__list" data-bsws-rail-list></div>';
    inner.insertBefore(rail, inner.firstChild);

    // Event delegation — single click handler survives tile rebuilds. Real
    // user clicks were dying because syncRail rebuilds the rail in response
    // to engine mutations, replacing the tile between mousedown and mouseup.
    rail.addEventListener('click', function (e) {
      // Delete button takes precedence — proxy the click to the engine's
      // native Delete link inside <item-no> for the matching block.
      var del = e.target.closest('.bsws-rail__delete');
      if (del) {
        e.preventDefault();
        e.stopPropagation();
        var delIdx = parseInt(del.dataset.bswsTileIdx, 10);
        if (isNaN(delIdx)) return;
        var dTile = del.closest('.bsws-rail__tile');
        var unsupportedDelete = dTile && dTile.classList.contains('bsws-rail__tile--unsupported');
        var dw = document.querySelector('multi-upload-wrapper');
        if (!dw) return;
        var dBlocks = dw.querySelectorAll('uploaded-files-block');
        var dBlock = dBlocks[delIdx];
        if (!dBlock) return;
        // Unsupported files: skip the engine's "Are you sure you would like
        // to remove this file?" confirmation. Engine's click handler at
        // bySize_popular.js:1667 is synchronous — it clones
        // template[data-multi-id="fileRemove"] (a <file-remove-wrapper-multi>)
        // and appends to <body>. The dialog is in DOM the instant
        // engineDelete.click() returns, so we find and click the confirm
        // button (.fileRemoveBlock__removeFile) in the same JS task. No
        // paint happens between append and remove, so the dialog never
        // flashes on screen. The CSS body-class hide is a backup in case
        // the engine ever switches to async dialog rendering.
        if (unsupportedDelete) {
          document.body.classList.add('bsws-suppress-remove-dialog');
        }
        // Move the size guide out of the block before the engine destroys
        // it — the guide is a singleton moved per-selection; without
        // parking, deleting the active block takes the guide with it and
        // it can't be re-attached to the next-selected block.
        parkSizeGuideFromBlock(dBlock);
        var engineDelete = dBlock.querySelector('item-no .itemNo__action a');
        if (engineDelete) engineDelete.click();
        if (unsupportedDelete) {
          var confirmBtn = document.querySelector(
            'file-remove-wrapper-multi .fileRemoveBlock__removeFile, ' +
            'file-remove-wrapper .fileRemoveBlock__removeFile'
          );
          if (confirmBtn) confirmBtn.click();
          // Engine's confirm handler is async (bySize_popular.js:1560);
          // it resolves the actual block removal and tears down the
          // wrapper. Clear the suppression after a beat so future user-
          // initiated deletes (on supported tiles) show the dialog
          // normally.
          setTimeout(function () {
            document.body.classList.remove('bsws-suppress-remove-dialog');
          }, 100);
        }
        return;
      }
      // Add-Another tile — same upload path as the Red dropzone's Browse
      // button. Lives as the first child of the rail list with a distinct
      // class so the regular tile-select branch below skips it cleanly.
      var addTile = e.target.closest('.bsws-rail__tile-add');
      if (addTile) {
        e.preventDefault();
        clickRedBrowse();
        return;
      }
      var tile = e.target.closest('.bsws-rail__tile');
      if (!tile) return;
      // Unsupported tiles are not selectable — engine has no preview / form
      // for them. User must use the delete X to remove and re-upload.
      if (tile.classList.contains('bsws-rail__tile--unsupported')) return;
      var idx = parseInt(tile.dataset.bswsTileIdx, 10);
      if (isNaN(idx)) return;
      var w = document.querySelector('multi-upload-wrapper');
      if (!w) return;
      // Delegated select uses the shared helper so pager prev/next and rail
      // tile click follow identical logic (selection class, engine nudge,
      // prices table refresh, pager sync).
      selectBlockByIdx(w, idx);
    });
  }

  // Nudge the engine to populate derived fields (height, currentHeight,
  // currentWidth, prices, totals) for a block that may have been skipped
  // while hidden. Used on (a) initial multi-upload — non-selected blocks
  // never receive the engine's keyup-driven recalc — and (b) rail-tile
  // selection changes.
  //
  // Two-step nudge:
  //   1. Backfill height from natural aspect ratio if missing/NaN.
  //   2. Dispatch input + change + keyup. The engine's dimension-recalc
  //      handler at bySize_popular.js:1268 listens for keyup specifically
  //      (not input/change), so without keyup the engine never updates
  //      fileDetails.currentHeight for the second block on initial render
  //      and the cart submit ships height = NaN.
  function nudgeEngine(block) {
    var widthInput  = block.querySelector('input[name="width__value"]');
    var heightInput = block.querySelector('input[name="height__value"]');
    var hero        = block.querySelector('.fileupload_hero');
    if (heightInput && (heightInput.value === '' || isNaN(+heightInput.value)) && widthInput) {
      var w = +widthInput.value || 0;
      if (w > 0 && hero && hero.naturalWidth && hero.naturalHeight) {
        var ratio = hero.naturalHeight / hero.naturalWidth;
        var h = +(w * ratio).toFixed(2);
        heightInput.value = String(h);
      }
    }
    // Symmetric case: in multi mode, the engine sometimes populates height
    // but leaves width blank (different code path than single — engine writes
    // via `parentContainer+' sizes-blocks .widthHeight__custom[item=X]'`
    // selectors that don't always resolve per-block). Backfill width from
    // height × aspect when we have a valid hero.
    if (widthInput && (widthInput.value === '' || isNaN(+widthInput.value)) && heightInput) {
      var h2 = +heightInput.value || 0;
      if (h2 > 0 && hero && hero.naturalWidth && hero.naturalHeight) {
        var ratio2 = hero.naturalWidth / hero.naturalHeight;
        var w2 = +(h2 * ratio2).toFixed(2);
        widthInput.value = String(w2);
      }
    }
    [widthInput, heightInput].forEach(function (i) {
      if (!i) return;
      i.dispatchEvent(new Event('input',  { bubbles: true }));
      i.dispatchEvent(new Event('change', { bubbles: true }));
      i.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
    });
  }

  // On initial multi-upload, non-selected blocks never get nudged (the rail-
  // click nudge only fires when the user explicitly switches blocks). That
  // leaves the engine's fileDetails.currentHeight unset for those blocks so
  // their cart line items submit "Height: NaN". Walk all blocks once their
  // hero image is loaded and the engine has finished registering them, then
  // nudge. Tracked via block.dataset.bswsNudged so we only run once per
  // block per page.
  //
  // Readiness gates (must ALL be true before we nudge — earlier nudges crash
  // the engine's calculateDPILineItem at bySize_popular.js:3483 with null
  // fileType because getFileDetailsFunction(blockNo) returns null mid-flight):
  //   1. .fileupload_hero has natural dimensions (image actually loaded)
  //   2. width__value input has a numeric value
  //   3. <file-progress> inside the block has .hidden class (engine's
  //      official "done loading" marker, set at bySize_popular.js:3161 for
  //      multi mode and :2682 elsewhere)
  //   4. getFileDetailsFunction(blockNo) returns an object with fileType
  // Engine bug workaround: in multi mode the engine fails to detect
  // file dimensions correctly for:
  //   * Raster files (png/jpg/svg) — `getImageSizeFromUrl()` at
  //     bySize_popular.js:2613 returns pixel dimensions ~25.4× smaller
  //     than the actual file (mm-per-inch bug). 2151px file renders as
  //     0.28" instead of 7.17".
  //   * Vector / PDF / PSD files (ai/eps/pdf/psd) — engine never calls
  //     `sendApiRequest()` in multi mode for these types, so dimensions
  //     stay at `file.designWidth/designHeight` which the backend
  //     doesn't reliably populate. Single mode handles these correctly
  //     via `pdp_transferBySize.js:4031-4063` (API call + ×4.1666×300
  //     for ai/eps, ×300 for pdf/psd, then ÷72 for inches).
  //
  // This function replicates single-mode's logic per multi block. It
  // reads fileExt from `getFileDetailsFunction(blockNo)`, branches on
  // image vs. vector/PDF, computes correct dimensions, writes inputs
  // and syncs engine fileDetails so tab/qty changes don't revert.
  // Idempotent via `data-bsws-dim-fixed`; in-flight API call gated by
  // `data-bsws-dim-fixing`.
  function fixMultiBlockDimensions(block) {
    if (!block) return;
    if (block.dataset.bswsDimFixing === '1') return;
    if (block.dataset.bswsDimFixed === '1') {
      // Engine's updatePropotionalSizes (pdp_transferBySize-multiupload.js:1400)
      // recomputes heights on every block-switch and selection event using a
      // global `getNewRatio(parentContainer + ' .fileupload_hero')`. When
      // parentContainer resolves to a hero that isn't visible/laid-out
      // (post-deletion in particular), .width()/.height() return 0 and
      // calculateNewWidth_orNewHeight produces NaN. jQuery `.val(NaN)` on
      // <input type="number"> resolves to empty, so blocks that were
      // previously fixed end up with a populated width but a blank height.
      // Re-enter the fixer to write the correct hero-derived height back.
      var maybeRow = block.querySelector('.widthHeight__custom[item][option-selected="custom"]');
      var maybeH = maybeRow && maybeRow.querySelector('.widthHeight__value[name="height__value"]');
      var maybeHVal = maybeH ? parseFloat(maybeH.value) : NaN;
      if (maybeH && (maybeH.value === '' || !(maybeHVal > 0))) {
        delete block.dataset.bswsDimFixed;
      } else {
        return;
      }
    }
    var blockNo = block.getAttribute('block-no');
    if (!blockNo || typeof window.getFileDetailsFunction !== 'function') return;
    var details;
    try { details = window.getFileDetailsFunction(blockNo); } catch (_) { return; }
    if (!details) return;
    var fileUrl = details.imgIxFile || details.fileURL || details.url || '';
    var fileExt = String(details.fileExt || details.fileType ||
      (fileUrl.split('.').pop() || '').split('?')[0]).toLowerCase();
    if (!fileExt) return;
    // Unknown extension — bail and unblock the loading overlay. Without
    // marking fixed the overlay would stall forever on uncommon types.
    if (fileExt !== 'png' && fileExt !== 'jpg' && fileExt !== 'jpeg' &&
        fileExt !== 'svg' && fileExt !== 'ai' && fileExt !== 'eps' &&
        fileExt !== 'pdf' && fileExt !== 'psd') {
      block.dataset.bswsDimFixed = '1';
      return;
    }
    var customRow = block.querySelector('.widthHeight__custom[item][option-selected="custom"]');
    if (!customRow) return;
    var wInput = customRow.querySelector('.widthHeight__value[name="width__value"]');
    var hInput = customRow.querySelector('.widthHeight__value[name="height__value"]');
    if (!wInput || !hInput) return;

    if (fileExt === 'png' || fileExt === 'jpg' || fileExt === 'jpeg' || fileExt === 'svg') {
      // Raster path: hero.naturalWidth is reliable, divide by 300 DPI.
      var hero = block.querySelector('.fileupload_hero');
      if (!hero || !hero.naturalWidth || !hero.naturalHeight) return;
      var heroSrc = hero.src || '';
      if (heroSrc.indexOf('transparent') !== -1) return;
      var trueWInch = hero.naturalWidth / 300;
      var trueHInch = hero.naturalHeight / 300;
      var curW = parseFloat(wInput.value) || 0;
      var curH = parseFloat(hInput.value);
      if (curW <= 0) return;
      // Engine occasionally wipes height to empty/NaN via its global ratio
      // recompute (see updatePropotionalSizes in
      // pdp_transferBySize-multiupload.js:1400). Treat "width is reasonable
      // AND height is a positive number" as the only valid skip — otherwise
      // re-derive both from the block's hero.
      if (trueWInch / curW < 10 && curH > 0) {
        // Already correct — mark fixed so the loading overlay
        // (ensureMultiUploadOverlay) doesn't stall waiting for us.
        block.dataset.bswsDimFixed = '1';
        return;
      }
      applyMultiBlockDimensions(block, customRow, wInput, hInput, trueWInch, trueHInch);
      block.dataset.bswsDimFixed = '1';
    } else if (fileExt === 'ai' || fileExt === 'eps' || fileExt === 'pdf' || fileExt === 'psd') {
      // Vector / PDF / PSD path: call the engine's sendApiRequest.
      if (typeof window.sendApiRequest !== 'function' || !fileUrl) return;
      block.dataset.bswsDimFixing = '1';
      var apiUrl = fileUrl;
      var s3Key = details.s3Key || details.s3key || null;
      if (fileExt === 'ai' || fileExt === 'eps') {
        apiUrl = fileUrl + (fileUrl.indexOf('?') === -1 ? '?' : '&') + 'trim=colorUnlessAlpha';
      } else if (fileExt === 'pdf') {
        apiUrl = fileUrl + (fileUrl.indexOf('?') === -1 ? '?' : '&') + 'fm=png';
      }
      Promise.resolve(window.sendApiRequest(apiUrl, s3Key)).then(function (res) {
        delete block.dataset.bswsDimFixing;
        if (!res || res.success !== true || !res.data || !res.data.dimensions) {
          // API didn't return dimensions — mark fixed anyway so the
          // multi loading overlay doesn't stall on this block.
          block.dataset.bswsDimFixed = '1';
          return;
        }
        var dims = res.data.dimensions;
        var widthPx, heightPx;
        if (fileExt === 'ai' || fileExt === 'eps') {
          // Single uses x4.1666666666 (PostScript points → inches
          // conversion factor that engine applies before x300 DPI).
          widthPx = dims.width * 4.166666666666667 * 300;
          heightPx = dims.height * 4.166666666666667 * 300;
        } else {
          // PDF / PSD: dimensions are already in inches per the API.
          widthPx = dims.width * 300;
          heightPx = dims.height * 300;
        }
        // Engine's single-mode formula writes inches as px/72 (see
        // pdp_transferBySize.js:4058-4059).
        var wInch = widthPx / 72;
        var hInch = heightPx / 72;
        applyMultiBlockDimensions(block, customRow, wInput, hInput, wInch, hInch);
        block.dataset.bswsDimFixed = '1';
      }).catch(function () {
        delete block.dataset.bswsDimFixing;
        block.dataset.bswsDimFixed = '1'; // unblock the loading overlay
      });
    }
  }

  // Shared writer used by both the raster and vector/PDF paths.
  // Clamps to engine's 22" max (otherwise
  // normalizeMultiUploadCustomDimensions, bySize_popular.js:90, scales
  // further on its own). Syncs engine fileDetails so subsequent
  // engine reads (tab switch, qty change) see the corrected values.
  function applyMultiBlockDimensions(block, row, wInput, hInput, wInch, hInch) {
    var scale = Math.min(22 / Math.max(wInch, hInch), 1);
    var newW = (wInch * scale).toFixed(2);
    var newH = (hInch * scale).toFixed(2);
    wInput.value = newW;
    wInput.setAttribute('value', newW);
    hInput.value = newH;
    hInput.setAttribute('value', newH);
    row.setAttribute('w', newW);
    row.setAttribute('h', newH);
    row.setAttribute('size', newW + 'x' + newH);
    // Clear any stale DPI warning the engine set against the bogus
    // initial dimensions. Also blank the latch and the row attr so
    // the synchronous DPI guard (attachDpiWarningGuard) doesn't
    // re-add `.active` from a pre-fix snapshot. Engine will re-evaluate
    // freshly via the input event we dispatch below, which is the
    // authoritative state.
    var dpiEl = row.querySelector('dpi-warning');
    if (dpiEl) dpiEl.classList.remove('active');
    row.setAttribute('dpi-warning', '');
    delete row.dataset.bswsDpiLatched;
    // Suppress any DPI warning the engine adds during the next ~4s
    // window. Block-switch triggers calculateDPILineItem which can
    // briefly mark the row bad using stale global state
    // (uploadedFileWidth/Height from a different design) before
    // recomputing correctly. The guard strips erroneous adds during
    // this window.
    row.dataset.bswsDpiSuppressedUntil = String(Date.now() + 4000);
    // Also update the engine's global pixel dims to match this
    // block's true hero size so its DPI math has the right baseline.
    var hero = block.querySelector('.fileupload_hero');
    if (hero && hero.naturalWidth > 0) {
      try {
        window.uploadedFileWidth = hero.naturalWidth;
        window.uploadedFileHeight = hero.naturalHeight;
      } catch (_) {}
    }
    var blockNo = block.getAttribute('block-no');
    if (blockNo && typeof window.getFileDetailsFunction === 'function') {
      try {
        var details = window.getFileDetailsFunction(blockNo);
        if (details) {
          details.currentWidth = newW;
          details.currentHeight = newH;
          details.fileWidth_inch = newW;
          details.fileHeight_inch = newH;
          if (typeof details.vector_currentWidth !== 'undefined') {
            details.vector_currentWidth = newW;
            details.vector_currentHeight = newH;
          }
        }
      } catch (_) {}
    }
    // Bump the row's last-edit timestamp so the DPI guard's edit
    // window (last 3500ms) is open when the engine reacts to the
    // dispatched input event below — engine's removeClass call from
    // its DPI recomputation must be allowed, not reverted.
    row.dataset.bswsLastEdit = String(Date.now());
    try { wInput.dispatchEvent(new Event('input', { bubbles: true })); } catch (_) {}
    try { wInput.dispatchEvent(new Event('keyup', { bubbles: true })); } catch (_) {}
  }

  // Size-guide heading bar — ported verbatim from Owen's source theme
  // (V3PDP NO DELETE, 146056544339). Injects the single "Ninja Size Guide -
  // See your design on our most popular sizes" bar as the first child of
  // .dtf_imgix_images .dtf_body_image. Targets that grid container DIRECTLY
  // (no .bsws-tabpanel--guide reference), so it works in the un-nested v3
  // single-mode structure. The bar lands in the grid's `auto` row, which
  // also restores even tile rows (the C.2b CSS guard self-disables once the
  // bar exists). Idempotent: re-running won't duplicate the bar.
  function ensureSizeGuideBars() {
    var body = document.querySelector('.dtf_imgix_images .dtf_body_image');
    if (!body) return;
    var HTML = '<strong>Ninja Size Guide</strong> - See your design on our most popular sizes';
    var top = body.querySelector(':scope > .bsws-size-guide-bar.is-top');
    if (!top) {
      top = document.createElement('div');
      top.className = 'bsws-size-guide-bar is-top';
      top.innerHTML = HTML;
      body.insertBefore(top, body.firstChild);
    } else {
      if (top.innerHTML !== HTML) top.innerHTML = HTML;
      if (top !== body.firstChild) body.insertBefore(top, body.firstChild);
    }
    var bot = body.querySelector(':scope > .bsws-size-guide-bar.is-bot');
    if (bot) bot.remove();
  }

  // Single-mode dimension repair — same engine misread as multi happens
  // in single on v3 (engine reads 0.25"×0.26" for a 2000×2089 hero). v2's
  // engine path produces correct dimensions for the same upload, so this
  // function mirrors v2 behavior: read `hero.naturalWidth / 300` from the
  // engine's single-mode preview-box and write that into the Width/Height
  // inputs when the engine has produced an obviously-wrong value (ratio
  // > 10× off) OR the height is blank/NaN (engine's silent
  // updatePropotionalSizes wipe). Idempotent: bails when the inputs
  // already hold sensible values. Called from scan() every tick.
  function fixSingleDimensions() {
    if (document.body.classList.contains('bsws-multi')) return;
    if (!document.body.classList.contains('image-uploaded')) return;
    var uc = document.querySelector('upload-controls');
    if (!uc) return;
    var customRow = uc.querySelector('sizes-blocks .widthHeight__custom[item][option-selected="custom"]');
    if (!customRow) return;
    var wInput = customRow.querySelector('input[name="width__value"]');
    var hInput = customRow.querySelector('input[name="height__value"]');
    if (!wInput || !hInput) return;
    var hero = uc.querySelector('preview-box .fileupload_hero');
    if (!hero || !hero.naturalWidth || !hero.naturalHeight) return;
    var heroSrc = hero.src || '';
    if (heroSrc.indexOf('transparent') !== -1) return;
    var trueWInch = hero.naturalWidth / 300;
    var trueHInch = hero.naturalHeight / 300;
    var curW = parseFloat(wInput.value) || 0;
    var curH = parseFloat(hInput.value);
    if (curW <= 0) return;
    if (trueWInch / curW < 10 && curH > 0) return;
    var scale = Math.min(22 / Math.max(trueWInch, trueHInch), 1);
    var newW = (trueWInch * scale).toFixed(2);
    var newH = (trueHInch * scale).toFixed(2);
    wInput.value = newW;
    wInput.setAttribute('value', newW);
    hInput.value = newH;
    hInput.setAttribute('value', newH);
    customRow.setAttribute('w', newW);
    customRow.setAttribute('h', newH);
    customRow.setAttribute('size', newW + 'x' + newH);
    var dpiEl = customRow.querySelector('dpi-warning');
    if (dpiEl) dpiEl.classList.remove('active');
    customRow.setAttribute('dpi-warning', '');
    try {
      window.uploadedFileWidth = hero.naturalWidth;
      window.uploadedFileHeight = hero.naturalHeight;
    } catch (_) {}
    try { wInput.dispatchEvent(new Event('input', { bubbles: true })); } catch (_) {}
    try { wInput.dispatchEvent(new Event('keyup', { bubbles: true })); } catch (_) {}
  }

  function ensureNudgedBlocks(wrapper) {
    var blocks = wrapper.querySelectorAll('uploaded-files-block');
    Array.prototype.forEach.call(blocks, function (block) {
      if (block.dataset.bswsNudged === '1') return;
      var hero = block.querySelector('.fileupload_hero');
      if (!hero || !hero.naturalWidth || !hero.naturalHeight) return;
      var widthInput  = block.querySelector('input[name="width__value"]');
      var heightInput = block.querySelector('input[name="height__value"]');
      var hasW = widthInput  && widthInput.value  && !isNaN(+widthInput.value);
      var hasH = heightInput && heightInput.value && !isNaN(+heightInput.value);
      // Accept either dimension being valid — nudgeEngine will backfill the
      // missing one from hero aspect ratio. Earlier this gate required width
      // specifically, but in multi the engine sometimes lands height-only,
      // which left the gate stuck open forever and the cart submitted blanks.
      if (!hasW && !hasH) return;
      var fp = block.querySelector('file-progress');
      if (fp && !fp.classList.contains('hidden')) return;
      var blockNo = block.getAttribute('block-no');
      if (blockNo && typeof window.getFileDetailsFunction === 'function') {
        var details;
        try { details = window.getFileDetailsFunction(blockNo); } catch (_) { return; }
        if (!details || !details.fileType) return;
      }
      try {
        nudgeEngine(block);
        block.dataset.bswsNudged = '1';
      } catch (e) {
        // Defensive: if the engine still races despite the gates above, log
        // and retry on the next scan tick rather than propagating uncaught.
        console.warn('[bsws] nudge deferred', e && e.message);
      }
    });
  }

  function teardownRail() {
    if (rail && rail.parentNode) rail.parentNode.removeChild(rail);
    rail = null;
    // Clear our selection class
    Array.prototype.forEach.call(
      document.querySelectorAll('uploaded-files-block.bsws-selected'),
      function (b) { b.classList.remove('bsws-selected'); }
    );
  }

  // Render rail tiles based on the engine's current blocks. We only REBUILD
  // tile elements when the block count changes; otherwise we just update
  // each existing tile's content in place. This keeps the same DOM nodes
  // alive across engine mutations so user clicks (mousedown→mouseup) don't
  // get torn down mid-press.
  function syncRail(wrapper) {
    if (!rail) return;
    var list = rail.querySelector('[data-bsws-rail-list]');
    if (!list) return;
    var blocks = wrapper.querySelectorAll('uploaded-files-block');
    if (!blocks.length) { list.innerHTML = ''; return; }

    // Decide which block is selected: keep current if still present, else first.
    var selected = wrapper.querySelector('uploaded-files-block.bsws-selected');
    if (!selected || !document.body.contains(selected)) {
      Array.prototype.forEach.call(blocks, function (b) { b.classList.remove('bsws-selected'); });
      selected = blocks[0];
      selected.classList.add('bsws-selected');
    }

    // Add-Another tile — first child of the list. Coexists with the Red
    // dropzone (.bsws-flow__add-another) below the workspace; both trigger
    // the same file picker via clickRedBrowse(). Distinct class so the
    // regular tile loop and click branch don't pick it up.
    var addTile = list.querySelector('.bsws-rail__tile-add');
    if (!addTile) {
      addTile = document.createElement('button');
      addTile.type = 'button';
      addTile.className = 'bsws-rail__tile-add';
      addTile.setAttribute('aria-label', 'Add another design');
      addTile.innerHTML =
        '<span class="bsws-rail__tile-add__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 16 16" focusable="false"><path d="M8 2v12 M2 8h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</span>' +
        '<span class="bsws-rail__tile-add__meta">' +
          '<span class="bsws-rail__tile-add__title">Add another</span>' +
          '<span class="bsws-rail__tile-add__sub">stack discounts</span>' +
        '</span>';
      list.insertBefore(addTile, list.firstChild);
    } else if (list.firstChild !== addTile) {
      list.insertBefore(addTile, list.firstChild);
    }

    // Reconcile tile count with block count (excluding the add-another tile)
    var existingTiles = list.querySelectorAll('.bsws-rail__tile');
    if (existingTiles.length !== blocks.length) {
      // Rebuild only the regular tiles; keep the add-another tile in place.
      Array.prototype.forEach.call(existingTiles, function (t) { t.remove(); });
      for (var i = 0; i < blocks.length; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bsws-rail__tile';
        btn.dataset.bswsTileIdx = String(i);
        list.appendChild(btn);
      }
      existingTiles = list.querySelectorAll('.bsws-rail__tile');
    }

    // Detect stuck blocks (engine never finished processing — almost always
    // an unsupported file type). Engine has no clean per-block "rejected"
    // signal in the DOM, so we use a time-based heuristic: a block that
    // hasn't loaded its hero image after STUCK_TIMEOUT_MS is treated as
    // unsupported. Scheduled re-scans keep this fresh without DOM churn.
    var STUCK_TIMEOUT_MS = 12000;
    var hasProcessingBlock = false;

    // Update each tile's content + selection class in place
    Array.prototype.forEach.call(blocks, function (block, i) {
      var tile = existingTiles[i];
      if (!tile) return;
      tile.classList.toggle('is-selected', block === selected);
      // Stamp first-seen time so we can detect blocks that never finish
      // loading (unsupported file types).
      if (!block.dataset.bswsObservedAt) {
        block.dataset.bswsObservedAt = String(Date.now());
      }
      var hero = block.querySelector('.fileupload_hero');
      var heroSrc = hero && hero.src ? hero.src : '';
      var ready = heroSrc && heroSrc.indexOf('transparent.png') === -1 && heroSrc.length > 0;
      var observedAt = parseInt(block.dataset.bswsObservedAt, 10) || Date.now();
      var unsupported = !ready && (Date.now() - observedAt) > STUCK_TIMEOUT_MS;
      if (!ready && !unsupported) hasProcessingBlock = true;
      var summary = getBlockSummary(block);
      var qty = summary.qty;
      var width = summary.width;
      var height = summary.height;
      var touched = block.classList.contains('bsws-touched');
      var precutYes = block.dataset.bswsPrecut === 'Yes';
      var stateKey = unsupported ? 'u' : (ready ? 'r:' + heroSrc : 'p');
      var newKey =
        stateKey + '|' + qty + '|' + width + '|' + height + '|' +
        i + '|' + (precutYes ? 'pc' : 'np') + '|' + (touched ? 't' : 'x') +
        '|' + (block === selected ? 's' : 'n');
      // Only update innerHTML if the visual state changed
      if (tile.dataset.bswsKey === newKey) return;
      tile.dataset.bswsKey = newKey;
      tile.classList.toggle('bsws-rail__tile--unsupported', unsupported);
      tile.classList.toggle('bsws-rail__tile--touched', touched && !unsupported);
      tile.classList.toggle('bsws-rail__tile--untouched', !touched && !unsupported);
      var thumbStyle = ready ? ' style="background-image:url(' + JSON.stringify(heroSrc).slice(1, -1) + ')"' : '';
      var deleteBtn =
        '<span class="bsws-rail__delete" data-bsws-tile-idx="' + i + '" role="button" aria-label="Delete upload ' + (i + 1) + '">' +
          '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2 L12 12 M12 2 L2 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</span>';
      // Touched/untouched status indicator. Filled ✓ once the user has
      // interacted with image/size/qty for this block; empty ◯ until then.
      // Memory rule: selection alone does NOT mark touched.
      var statusIndicator =
        '<span class="bsws-rail__status" data-bsws-touched="' + (touched ? '1' : '0') + '" aria-hidden="true">' +
          (touched
            ? '<svg viewBox="0 0 16 16" focusable="false"><path d="M3.5 8.5 L7 12 L13 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            : '<svg viewBox="0 0 16 16" focusable="false"><circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>'
          ) +
        '</span>';
      var precutPill = precutYes ? '<span class="bsws-rail__precut-pill">PRE</span>' : '';
      if (unsupported) {
        tile.innerHTML =
          '<span class="bsws-rail__thumb bsws-rail__thumb--unsupported" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" focusable="false"><path d="M12 2 L22 20 L2 20 Z M12 9 v5 M12 17 v.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</span>' +
          '<span class="bsws-rail__meta">' +
            '<span class="bsws-rail__name">Upload ' + (i + 1) + '</span>' +
            '<span class="bsws-rail__unsupported">Unsupported file<br><strong>Click × to remove</strong></span>' +
          '</span>' +
          deleteBtn;
      } else if (ready) {
        // Touched: show qty + dimensions summary. Untouched: show "Tap to set"
        // placeholder. Both show the status indicator (filled ✓ vs empty ◯).
        var metaInner = touched
          ? (
              '<span class="bsws-rail__qty">' + qty + ' pcs' + precutPill + '</span>' +
              '<span class="bsws-rail__dims">' + width + ' &times; ' + height + '</span>'
            )
          : (
              '<span class="bsws-rail__placeholder">Tap to set</span>' + precutPill
            );
        tile.innerHTML =
          '<span class="bsws-rail__thumb"' + thumbStyle + '></span>' +
          '<span class="bsws-rail__meta">' + metaInner + '</span>' +
          deleteBtn + statusIndicator;
      } else {
        tile.innerHTML =
          '<span class="bsws-rail__thumb bsws-rail__thumb--processing"><span class="bsws-rail__spinner"></span></span>' +
          '<span class="bsws-rail__meta"><span class="bsws-rail__processing">Processing…</span></span>' +
          deleteBtn;
      }
    });

    // The stuck-timeout transition happens purely on time, not on a DOM
    // mutation, so the MutationObserver won't re-fire scan on its own.
    // Schedule a re-sync while any block is still "processing" so it can
    // flip to "unsupported" once the timeout elapses.
    if (hasProcessingBlock) {
      setTimeout(function () {
        var w = document.querySelector('multi-upload-wrapper');
        if (w) syncRail(w);
      }, 1500);
    }
  }

  function addDebugBar() {
    if (document.querySelector('.bsws-debug-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'bsws-debug-bar';
    bar.style.cssText = 'position:fixed;top:8px;left:8px;z-index:99999;display:flex;gap:8px;padding:8px 10px;background:#FFF7E0;border:1px solid #E0C870;border-radius:6px;font:12px ui-monospace,monospace;align-items:center;';
    bar.innerHTML = '<strong style="margin-right:6px">DEBUG:</strong>';
    var btn = function (label, cb) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = label;
      b.style.cssText = 'padding:5px 12px;background:#222;color:#fff;border:none;border-radius:4px;font:inherit;cursor:pointer;';
      b.addEventListener('click', cb);
      bar.appendChild(b);
      return b;
    };
    btn('toggle bsws-multi', function () { document.body.classList.toggle('bsws-multi'); });
    btn('open popup', function () {
      var w = document.querySelector('multi-upload-wrapper'); if (w) w.classList.add('active');
    });
    btn('close popup', function () {
      var w = document.querySelector('multi-upload-wrapper'); if (w) w.classList.remove('active');
    });
    document.body.appendChild(bar);
  }
})();
